/* ---------------- INTEGRATION CONSTANTS ---------------- */
export const FETCH_INTEGRATIONS_REQUEST = 'FETCH_INTEGRATIONS_REQUEST'
export const FETCH_INTEGRATIONS_SUCCESS = 'FETCH_INTEGRATIONS_SUCCESS'
export const FETCH_INTEGRATIONS_FAIL = 'FETCH_INTEGRATIONS_FAIL'

/* ---------------- RIDER CONSTANTS ---------------- */
export const RIDER_ASSISTANCE_LIST_REQUEST = 'RIDER_ASSISTANCE_LIST_REQUEST'
export type RIDER_ASSISTANCE_LIST_REQUEST = typeof RIDER_ASSISTANCE_LIST_REQUEST

export const RIDER_ASSISTANCE_LIST_SUCCESS = 'RIDER_ASSISTANCE_LIST_SUCCESS'
export type RIDER_ASSISTANCE_LIST_SUCCESS = typeof RIDER_ASSISTANCE_LIST_SUCCESS

export const RIDER_ASSISTANCE_LIST_FAILURE = 'RIDER_ASSISTANCE_LIST_FAILURE'
export type RIDER_ASSISTANCE_LIST_FAILURE = typeof RIDER_ASSISTANCE_LIST_FAILURE

export const RIDER_LOCATION_LIST_REQUEST = 'RIDER_LOCATION_LIST_REQUEST'
export type RIDER_LOCATION_LIST_REQUEST = typeof RIDER_LOCATION_LIST_REQUEST

export const RIDER_LOCATION_LIST_SUCCESS = 'RIDER_LOCATION_LIST_SUCCESS'
export type RIDER_LOCATION_LIST_SUCCESS = typeof RIDER_LOCATION_LIST_SUCCESS

export const RIDER_LOCATION_LIST_FAILURE = 'RIDER_LOCATION_LIST_FAILURE'
export type RIDER_LOCATION_LIST_FAILURE = typeof RIDER_LOCATION_LIST_FAILURE

export const RIDER_LOCATION_ACTIVITY_LIST_REQUEST = 'RIDER_LOCATION_ACTIVITY_LIST_REQUEST'
export type RIDER_LOCATION_ACTIVITY_LIST_REQUEST = typeof RIDER_LOCATION_ACTIVITY_LIST_REQUEST

export const RIDER_LOCATION_ACTIVITY_LIST_SUCCESS = 'RIDER_LOCATIONRIDER_LOCATION_ACTIVITY_LIST_SUCCESS_LIST_SUCCESS'
export type RIDER_LOCATION_ACTIVITY_LIST_SUCCESS = typeof RIDER_LOCATION_ACTIVITY_LIST_SUCCESS

export const RIDER_LOCATION_ACTIVITY_LIST_FAILURE = 'RIDER_LOCATION_ACTIVITY_LIST_FAILURE'
export type RIDER_LOCATION_ACTIVITY_LIST_FAILURE = typeof RIDER_LOCATION_ACTIVITY_LIST_FAILURE

export const FILTER_RIDER_LOCATIONS = 'FILTER_RIDER_LOCATIONS'

export const RIDER_MEMBERSHIP_LIST_REQUEST = 'RIDER_MEMBERSHIP_LIST_REQUEST'
export type RIDER_MEMBERSHIP_LIST_REQUEST = typeof RIDER_MEMBERSHIP_LIST_REQUEST

export const RIDER_MEMBERSHIP_LIST_SUCCESS = 'RIDER_MEMBERSHIP_LIST_SUCCESS'
export type RIDER_MEMBERSHIP_LIST_SUCCESS = typeof RIDER_MEMBERSHIP_LIST_SUCCESS

export const RIDER_MEMBERSHIP_LIST_FAILURE = 'RIDER_MEMBERSHIP_LIST_FAILURE'
export type RIDER_MEMBERSHIP_LIST_FAILURE = typeof RIDER_MEMBERSHIP_LIST_FAILURE

export const RIDER_MEMBERSHIP_UPDATE_REQUEST = 'RIDER_MEMBERSHIP_UPDATE_REQUEST'
export type RIDER_MEMBERSHIP_UPDATE_REQUEST = typeof RIDER_MEMBERSHIP_UPDATE_REQUEST

export const RIDER_MEMBERSHIP_UPDATE_SUCCESS = 'RIDER_MEMBERSHIP_UPDATE_SUCCESS'
export type RIDER_MEMBERSHIP_UPDATE_SUCCESS = typeof RIDER_MEMBERSHIP_UPDATE_SUCCESS

export const RIDER_MEMBERSHIP_UPDATE_FAILURE = 'RIDER_MEMBERSHIP_UPDATE_FAILURE'
export type RIDER_MEMBERSHIP_UPDATE_FAILURE = typeof RIDER_MEMBERSHIP_UPDATE_FAILURE

export const RIDER_MOBILITY_OPTION_LIST_REQUEST = 'RIDER_MOBILITY_OPTION_LIST_REQUEST'
export type RIDER_MOBILITY_OPTION_LIST_REQUEST = typeof RIDER_MOBILITY_OPTION_LIST_REQUEST

export const RIDER_MOBILITY_OPTION_LIST_SUCCESS = 'RIDER_MOBILITY_OPTION_LIST_SUCCESS'
export type RIDER_MOBILITY_OPTION_LIST_SUCCESS = typeof RIDER_MOBILITY_OPTION_LIST_SUCCESS

export const RIDER_MOBILITY_OPTION_LIST_FAILURE = 'RIDER_MOBILITY_OPTION_LIST_FAILURE'
export type RIDER_MOBILITY_OPTION_LIST_FAILURE = typeof RIDER_MOBILITY_OPTION_LIST_FAILURE

export const RIDER_PERSONAL_INFO_REQUEST = 'RIDER_PERSONAL_INFO_REQUEST'
export type RIDER_PERSONAL_INFO_REQUEST = typeof RIDER_PERSONAL_INFO_REQUEST

export const RIDER_PERSONAL_INFO_SUCCESS = 'RIDER_PERSONAL_INFO_SUCCESS'
export type RIDER_PERSONAL_INFO_SUCCESS = typeof RIDER_PERSONAL_INFO_SUCCESS

export const RIDER_PERSONAL_INFO_FAILURE = 'RIDER_PERSONAL_INFO_FAILURE'
export type RIDER_PERSONAL_INFO_FAILURE = typeof RIDER_PERSONAL_INFO_FAILURE

export const RIDER_LIST_REQUEST = 'RIDER_LIST_REQUEST'
export type RIDER_LIST_REQUEST = typeof RIDER_LIST_REQUEST

export const RIDER_LIST_SUCCESS = 'RIDER_LIST_SUCCESS'
export type RIDER_LIST_SUCCESS = typeof RIDER_LIST_SUCCESS

export const RIDER_LIST_FAILURE = 'RIDER_LIST_FAILURE'
export type RIDER_LIST_FAILURE = typeof RIDER_LIST_FAILURE

export const RIDERS_SEARCH_REQUEST = 'RIDERS_SEARCH_REQUEST'
export type RIDERS_SEARCH_REQUEST = typeof RIDERS_SEARCH_REQUEST

export const RIDERS_SEARCH_SUCCESS = 'RIDERS_SEARCH_SUCCESS'
export type RIDERS_SEARCH_SUCCESS = typeof RIDERS_SEARCH_SUCCESS

export const RIDERS_SEARCH_FAILURE = 'RIDERS_SEARCH_FAILURE'
export type RIDERS_SEARCH_FAILURE = typeof RIDERS_SEARCH_FAILURE

export const RIDERS_ARCHIVE_REQUEST = 'RIDERS_ARCHIVE_REQUEST'
export type RIDERS_ARCHIVE_REQUEST = typeof RIDERS_ARCHIVE_REQUEST

export const RIDERS_ARCHIVE_SUCCESS = 'RIDERS_ARCHIVE_SUCCESS'
export type RIDERS_ARCHIVE_SUCCESS = typeof RIDERS_ARCHIVE_SUCCESS

export const RIDERS_ARCHIVE_FAILURE = 'RIDERS_ARCHIVE_FAILURE'
export type RIDERS_ARCHIVE_FAILURE = typeof RIDERS_ARCHIVE_FAILURE

export const RIDERS_RESTORE_ARCHIVE_REQUEST = 'RIDERS_RESTORE_ARCHIVE_REQUEST'
export type RIDERS_RESTORE_ARCHIVE_REQUEST = typeof RIDERS_RESTORE_ARCHIVE_REQUEST

export const RIDERS_RESTORE_ARCHIVE_SUCCESS = 'RIDERS_RESTORE_ARCHIVE_SUCCESS'
export type RIDERS_RESTORE_ARCHIVE_SUCCESS = typeof RIDERS_RESTORE_ARCHIVE_SUCCESS

export const RIDERS_RESTORE_ARCHIVE_FAILURE = 'RIDERS_RESTORE_ARCHIVE_FAILURE'
export type RIDERS_RESTORE_ARCHIVE_FAILURE = typeof RIDERS_RESTORE_ARCHIVE_FAILURE

export const CLEAR_RIDER_SEARCH = 'CLEAR_RIDER_SEARCH'
export type CLEAR_RIDER_SEARCH = typeof CLEAR_RIDER_SEARCH

export const SELECT_RIDER_FOR_TRIP = 'SELECT_RIDER_FOR_TRIP'
export type SELECT_RIDER_FOR_TRIP = typeof SELECT_RIDER_FOR_TRIP

export const APPLY_PROMOTION = 'APPLY_PROMOTION'
export const APPLY_PROMOTION_FAIL = 'APPLY_PROMOTION_FAIL'
export const APPLY_PROMOTION_SUCCESS = 'APPLY_PROMOTION_SUCCESS'

export const GET_APPLIED_PROMOTIONS = 'GET_APPLIED_PROMOTIONS'
export const GET_APPLIED_PROMOTIONS_FAILURE = 'GET_APPLIED_PROMOTIONS_FAILURE'
export const GET_APPLIED_PROMOTIONS_SUCCESS = 'GET_APPLIED_PROMOTIONS_SUCCESS'

export const DELETE_APPLIED_PROMOTIONS_FAILURE = 'DELETE_APPLIED_PROMOTIONS_FAILURE'

/* ----------------RIDER LOCATION-------------- */
export const RIDER_CREATE_LOCATION_REQUEST = 'RIDER_CREATE_LOCATION_REQUEST'
export const RIDER_CREATE_LOCATION_SUCCESS = 'RIDER_CREATE_LOCATION_SUCCESS'
export const RIDER_CREATE_LOCATION_FAILURE = 'RIDER_CREATE_LOCATIONS_FAILURE'
export const RIDER_REMOVE_LOCATION_REQUEST = 'RIDER_REMOVE_LOCATION_REQUEST'
export const RIDER_REMOVE_LOCATION_SUCCESS = 'RIDER_REMOVE_LOCATION_SUCCESS'
export const RIDER_REMOVE_LOCATION_FAILURE = 'RIDER_REMOVE_LOCATION_FAILURE'
export const SET_RIDER_LOCATION_QUERY = 'SET_RIDER_LOCATION_QUERY'

/* ----------------TRIPS-------------- */
export const UPDATE_TRIP_FILTERS = 'UPDATE_TRIP_FILTERS'
export const UPDATE_TRIP_SUMMARY_FILTERS = 'UPDATE_TRIP_SUMMARY_FILTERS'
export const UPDATE_TRIP_DRIVER = 'UPDATE_TRIP_DRIVER'
export const SELECT_TRIP_ROWS = 'SELECT_TRIP_ROWS'
export const UPDATE_TEAM_MEMBER_FILTERS = 'UPDATE_TEAM_MEMBER_FILTERS'
export const RESET_TEAM_MEMBER_FILTERS = 'RESET_TEAM_MEMBER_FILTERS'
export const FEEDBACK_FILTERS = 'FEEDBACK_FILTERS'
export const SELECT_ORG_FOR_TRIP = 'SELECT_ORG_FOR_TRIP'
export const GET_TRIP_PRODUCT_PRICING_REQUEST = 'GET_TRIP_PRODUCT_PRICING_REQUEST'
export const GET_TRIP_PRODUCT_PRICING_SUCCESS = 'GET_TRIP_PRODUCT_PRICING_SUCCESS'
export const GET_TRIP_PRODUCT_PRICING_FAIL = 'GET_TRIP_PRODUCT_PRICING_FAIL'
export const ACTIVE_TRIPS_REQUEST = 'ACTIVE_TRIPS_REQUEST'
export const ACTIVE_TRIPS_SUCCESS = 'ACTIVE_TRIPS_SUCCESS'
export const ACTIVE_TRIPS_FAIL = 'ACTIVE_TRIPS_FAIL'
export const IMPORT_TRIPS_REQUEST = 'IMPORT_TRIPS_REQUEST'
export const IMPORT_TRIPS_SUCCESS = 'IMPORT_TRIPS_SUCCESS'
export const IMPORT_TRIPS_FAIL = 'IMPORT_TRIPS_FAIL'
export const LAST_ACTIVE_TRIPS_REQUEST = 'LAST_ACTIVE_TRIPS_REQUEST'
export const LAST_ACTIVE_TRIPS_SUCCESS = 'LAST_ACTIVE_TRIPS_SUCCESS'
export const LAST_ACTIVE_TRIPS_FAIL = 'LAST_ACTIVE_TRIPS_FAIL'
export const RECENT_TRIPS_SUCCESS = 'RECENT_TRIPS_SUCCESS'
export const RECENT_TRIPS_REQUEST = 'RECENT_TRIPS_REQUEST'
export const RECENT_TRIPS_FAIL = 'RECENT_TRIPS_FAIL'
export const USER_TRIPS_SUCCESS = 'USER_TRIPS_SUCCESS'
export const USER_TRIPS_REQUEST = 'USER_TRIPS_REQUEST'
export const USER_TRIPS_FAIL = 'USER_TRIPS_FAIL'
export const ZONE_TRIPS_REQUEST = 'ZONE_TRIPS_REQUEST'
export const ZONE_TRIPS_SUCCESS = 'ZONE_TRIPS_SUCCESS'
export const ZONE_TRIPS_FAIL = 'ZONE_TRIPS_FAIL'
export const TRIP_DRIVER_LOCATION_REQUEST = 'TRIP_DRIVER_LOCATION_REQUEST'
export const TRIP_DRIVER_LOCATION_SUCCESS = 'TRIP_DRIVER_LOCATION_SUCCESS'
export const TRIP_DRIVER_LOCATION_FAIL = 'TRIP_DRIVER_LOCATION_FAIL'

export const TRIP_ASSIGN_OPERATOR_REQUEST = 'TRIP_ASSIGN_OPERATOR_REQUEST'
export const TRIP_ASSIGN_OPERATOR_SUCCESS = 'TRIP_ASSIGN_OPERATOR_SUCCESS'
export const TRIP_ASSIGN_OPERATOR_FAIL = 'TRIP_ASSIGN_OPERATOR_FAIL'

export const MULTIPLE_TRIP_CANCEL_OPERATOR_REQUEST = 'MULTIPLE_TRIP_CANCEL_OPERATOR_REQUEST'
export const MULTIPLE_TRIP_CANCEL_OPERATOR_SUCCESS = 'MULTIPLE_TRIP_CANCEL_OPERATOR_SUCCESS'
export const MULTIPLE_TRIP_CANCEL_OPERATOR_FAIL = 'MULTIPLE_TRIP_CANCEL_OPERATOR_FAIL'

export const TRIP_ASSIGN_MULTIPLE_OPERATOR_REQUEST = 'TRIP_ASSIGN_MULTIPLE_OPERATOR_REQUEST'
export const MANUAL_COMPLETE_TRIP_SUCCESS = 'MANUAL_COMPLETE_TRIP_SUCCESS'
export const TRIP_ASSIGN_MULTIPLE_OPERATOR_FAIL = 'TRIP_ASSIGN_MULTIPLE_OPERATOR_FAIL'

export const MANUAL_COMPLETE_TRIP_REQUEST = 'MANUAL_COMPLETE_TRIP_REQUEST'
export const TRIP_ASSIGN_MULTIPLE_OPERATOR_SUCCESS = 'TRIP_ASSIGN_MULTIPLE_OPERATOR_SUCCESS'
export const MANUAL_COMPLETE_TRIP_FAIL = 'MANUAL_COMPLETE_TRIP_FAIL'

export const TRIP_RIDER_SEARCH_REQUEST = 'TRIP_RIDER_SEARCH_REQUEST'
export const TRIP_RIDER_SEARCH_SUCCESS = 'TRIP_RIDER_SEARCH_SUCCESS'
export const TRIP_RIDER_SEARCH_FAIL = 'TRIP_RIDER_SEARCH_FAIL'

export const TRIP_NOTES_UPDATE = 'RIDER_NOTES_UPDATE'
export const TRIP_CONFIRMATION_NUMBER_UPDATE = 'TRIP_CONFIRMATION_NUMBER_UPDATE'
export const TRIP_PROVIDER_ONE_NUMBER_UPDATE = 'TRIP_PROVIDER_ONE_NUMBER_UPDATE'

export const TRIP_REQUESTER_NAME = 'TRIP_REQUESTER_NAME'

export const TRIP_PAYMENTMODE_UPDATE = 'RIDER_PAYMENTMODE_UPDATE'
export const RIDER_COUNT_UPDATE = 'RIDER_COUNT_UPDATE'

export const SET_TRIP_PASSENGER_DETAILS = 'SET_TRIP_PASSENGER_DETAILS'
export const SET_TRIP_REQUEST_TOTAL_RIDERS_FARE = 'SET_TRIP_REQUEST_TOTAL_RIDERS_FARE'

export const TRIP_REQ_DETAILS_UPDATE = 'TRIP_REQ_DETAILS_UPDATE'

export const COMPLETE_TRIP_MANUALLY_REQUEST = 'COMPLETE_TRIP_MANUALLY_REQUEST'
export const COMPLETE_TRIP_MANUALLY_SUCCESS = 'COMPLETE_TRIP_MANUALLY_SUCCESS'
export const COMPLETE_TRIP_MANUALLY_FAILURE = 'COMPLETE_TRIP_MANUALLY_FAILURE'

export const CANCEL_BILLABLE_MANUALLY_REQUEST = 'CANCEL_BILLABLE_MANUALLY_REQUEST'
export const CANCEL_BILLABLE_MANUALLY_SUCCESS = 'CANCEL_BILLABLE_MANUALLY_SUCCESS'
export const CANCEL_BILLABLE_MANUALLY_FAILURE = 'CANCEL_BILLABLE_MANUALLY_FAILURE'

export const GET_UBER_DRIVER_NUMBER_REQUEST = 'GET_UBER_DRIVER_NUMBER_REQUEST'
export const GET_UBER_DRIVER_NUMBER_SUCCESS = 'GET_UBER_DRIVER_NUMBER_SUCCESS'
export const GET_UBER_DRIVER_NUMBER_FAILURE = 'GET_UBER_DRIVER_NUMBER_FAILURE'

export const TRIP_SHOW_MEMBERS = 'TRIP_SHOW_MEMBERS'
export const TRIP_HIDE_SHOW_MEMBERS = 'TRIP_HIDE_SHOW_MEMBERS'

export const TRIP_NOTES_PUSH_NOTIF_REQUEST = 'TRIP_NOTES_PUSH_NOTIF_REQUEST'
export const TRIP_NOTES_PUSH_NOTIF_SUCCESS_MESSAGE = 'TRIP_NOTES_PUSH_NOTIF_SUCCESS_MESSAGE'
export const TRIP_NOTES_PUSH_NOTIF_FAIL = 'TRIP_NOTES_PUSH_NOTIF_FAIL'

export const TRIP_TIME_PUSH_NOTIF_REQUEST = 'TRIP_TIME_PUSH_NOTIF_REQUEST'
export const TRIP_TIME_PUSH_NOTIF_SUCCESS_MESSAGE = 'TRIP_TIME_PUSH_NOTIF_SUCCESS_MESSAGE'
export const TRIP_TIME_PUSH_NOTIF_FAIL = 'TRIP_TIME_PUSH_NOTIF_FAIL'

export const TRIP_OPERATOR_PUSH_NOTIF_REQUEST = 'TRIP_OPERATOR_PUSH_NOTIF_REQUEST'
export const TRIP_OPERATOR_PUSH_NOTIF_SUCCESS_MESSAGE = 'TRIP_OPERATOR_PUSH_NOTIF_SUCCESS_MESSAGE'
export const TRIP_OPERATOR_PUSH_NOTIF_FAIL = 'TRIP_OPERATOR_PUSH_NOTIF_FAIL'

export const TRIP_CANCEL_PUSH_NOTIF_REQUEST = 'TRIP_CANCEL_PUSH_NOTIF_REQUEST'
export const TRIP_CANCEL_PUSH_NOTIF_SUCCESS_MESSAGE = 'TRIP_CANCEL_PUSH_NOTIF_SUCCESS_MESSAGE'
export const TRIP_CANCEL_PUSH_NOTIF_FAIL = 'TRIP_CANCEL_PUSH_NOTIF_FAIL'

export const ALLOTTED_TIME_PUSH_NOTIF_REQUEST = 'ALLOTTED_TIME_PUSH_NOTIF_REQUEST'
export const ALLOTTED_TIME_PUSH_NOTIF_SUCCESS_MESSAGE = 'ALLOTTED_TIME_PUSH_NOTIF_SUCCESS_MESSAGE'
export const ALLOTTED_TIME_PUSH_NOTIF_FAIL = 'ALLOTTED_TIME_PUSH_NOTIF_FAIL'

export const SAVE_DATA_REQUEST = 'SAVE_DATA_REQUEST'
export const SAVE_DATA_SUCCESS = 'SAVE_DATA_SUCCESS'
export const SAVE_DATA_FAILURE = 'SAVE_DATA_FAILURE'

export const SAVE_POLYLINE_BOUNDS_REQUEST = 'SAVE_POLYLINE_BOUNDS_REQUEST'
export const SAVE_POLYLINE_BOUNDS_SUCCESS = 'SAVE_POLYLINE_BOUNDS_SUCCESS'
export const SAVE_POLYLINE_BOUNDS_FAILURE = 'SAVE_POLYLINE_BOUNDS_FAILURE'

export const GET_DAILY_TRIP_LOG_REQUEST = 'GET_DAILY_TRIP_LOG_REQUEST'
export const GET_DAILY_TRIP_LOG_SUCCESS = 'GET_DAILY_TRIP_LOG_SUCCESS'
export const GET_DAILY_TRIP_LOG_FAILURE = 'GET_DAILY_TRIP_LOG_FAILURE'

export const GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_REQUEST = 'GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_REQUEST'
export const GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_SUCCESS = 'GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_SUCCESS'
export const GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_FAILURE = 'GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_FAILURE'

export const GET_TOTAL_TRIPS_PER_SERVICE_REQUEST = 'GET_TOTAL_TRIPS_PER_SERVICE_REQUEST'
export const GET_TOTAL_TRIPS_PER_SERVICE_SUCCESS = 'GET_TOTAL_TRIPS_PER_SERVICE_SUCCESS'
export const GET_TOTAL_TRIPS_PER_SERVICE_FAILURE = 'GET_TOTAL_TRIPS_PER_SERVICE_FAILURE'

export const GET_TRIPS_STATUS_COUNT_REQUEST = 'GET_TRIPS_STATUS_COUNT_REQUEST'
export const GET_TRIPS_STATUS_COUNT_SUCCESS = 'GET_TRIPS_STATUS_COUNT_SUCCESS'
export const GET_TRIPS_STATUS_COUNT_FAILURE = 'GET_TRIPS_STATUS_COUNT_FAILURE'

export const SET_CURRENT_TRIP = 'SET_CURRENT_TRIP'

export const RIDERS_ACTIVATE_REQUEST = 'RIDERS_ACTIVATE_REQUEST'
export const RIDERS_ACTIVATE_SUCCESS = 'RIDERS_ACTIVATE_SUCCESS'
export const RIDERS_ACTIVATE_FAILURE = 'RIDERS_ACTIVATE_FAILURE'

export const RIDERS_DEACTIVATE_REQUEST = 'RIDERS_DEACTIVATE_REQUEST'
export const RIDERS_DEACTIVATE_SUCCESS = 'RIDERS_DEACTIVATE_SUCCESS'
export const RIDERS_DEACTIVATE_FAILURE = 'RIDERS_DEACTIVATE_FAILURE'

export const RIDERS_CREATE_UPDATE_LOCATION = 'RIDERS_CREATE_UPDATE_LOCATION'

export const RIDERS_CREATE_ADD_LOCATION_REQUEST = 'RIDERS_CREATE_ADD_LOCATION_REQUEST'
export const RIDERS_CREATE_ADD_LOCATION_SUCCESS = 'RIDERS_CREATE_ADD_LOCATION_SUCCESS'
export const RIDERS_CREATE_ADD_LOCATION_FAILURE = 'RIDERS_CREATE_ADD_LOCATION_FAILURE'

export const RIDERS_ADD_PAYMENT_SOURCE_REQUEST = 'RIDERS_ADD_PAYMENT_SOURCE_REQUEST'
export const RIDERS_ADD_PAYMENT_SOURCE_SUCCESS = 'RIDERS_ADD_PAYMENT_SOURCE_SUCCESS'
export const RIDERS_ADD_PAYMENT_SOURCE_FAILURE = 'RIDERS_ADD_PAYMENT_SOURCE_FAILURE'

export const RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_REQUEST = 'RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_REQUEST'
export const RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_SUCCESS = 'RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_SUCCESS'
export const RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_FAILURE = 'RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_FAILURE'

export const RIDERS_REMOVE_PAYMENT_SOURCE_REQUEST = 'RIDERS_REMOVE_PAYMENT_SOURCE_REQUEST'
export const RIDERS_REMOVE_PAYMENT_SOURCE_SUCCESS = 'RIDERS_REMOVE_PAYMENT_SOURCE_SUCCESS'
export const RIDERS_REMOVE_PAYMENT_SOURCE_FAILURE = 'RIDERS_REMOVE_PAYMENT_SOURCE_FAILURE'

export const RIDERS_WALLET_REQUEST = 'RIDERS_WALLET_REQUEST'
export const RIDERS_WALLET_SUCCESS = 'RIDERS_WALLET_SUCCESS'
export const RIDERS_WALLET_FAILURE = 'RIDERS_WALLET_FAILURE'

export const RIDERS_WALLET_TRANSACTIONS_REQUEST = 'RIDERS_WALLET_TRANSACTIONS_REQUEST'
export const RIDERS_WALLET_TRANSACTIONS_SUCCESS = 'RIDERS_WALLET_TRANSACTIONS_SUCCESS'
export const RIDERS_WALLET_TRANSACTIONS_FAILURE = 'RIDERS_WALLET_TRANSACTIONS_FAILURE'

export const RIDERS_WALLET_TRANSACTION_HISTORY_REQUEST = 'RIDERS_WALLET_TRANSACTION_HISTORY_REQUEST'
export const RIDERS_WALLET_TRANSACTION_HISTORY_SUCCESS = 'RIDERS_WALLET_TRANSACTION_HISTORY_SUCCESS'
export const RIDERS_WALLET_TRANSACTION_HISTORY_FAILURE = 'RIDERS_WALLET_TRANSACTION_HISTORY_FAILURE'

export const RIDERS_CREATE_REQUEST = 'RIDERS_CREATE_REQUEST'
export const RIDERS_CREATE_SUCCESS = 'RIDERS_CREATE_SUCCESS'
export const RIDERS_CREATE_FAILURE = 'RIDERS_CREATE_FAILURE'

export const RIDERS_CREATE_FINISH = 'RIDERS_CREATE_FINISH'

export const RIDERS_UPDATE_PERSONAL_INFO_REQUEST = 'RIDERS_UPDATE_PERSONAL_INFO_REQUEST'
export const RIDERS_UPDATE_PERSONAL_INFO_SUCCESS = 'RIDERS_UPDATE_PERSONAL_INFO_SUCCESS'
export const RIDERS_UPDATE_PERSONAL_INFO_FAILURE = 'RIDERS_UPDATE_PERSONAL_INFO_FAILURE'

export const RIDERS_CREATE_CLEAR = 'RIDERS_CREATE_CLEAR'

export const RIDERS_UPDATE_ASSISTANCES_REQUEST = 'RIDERS_UPDATE_ASSISTANCES_REQUEST'
export const RIDERS_UPDATE_ASSISTANCES_SUCCESS = 'RIDERS_UPDATE_ASSISTANCES_SUCCESS'
export const RIDERS_UPDATE_ASSISTANCES_FAILURE = 'RIDERS_UPDATE_ASSISTANCES_FAILURE'

export const RIDERS_UPDATE_LOCATIONS_REQUEST = 'RIDERS_UPDATE_LOCATIONS_REQUEST'
export const RIDERS_UPDATE_LOCATIONS_SUCCESS = 'RIDERS_UPDATE_LOCATIONS_SUCCESS'
export const RIDERS_UPDATE_LOCATIONS_FAILURE = 'RIDERS_UPDATE_LOCATIONS_FAILURE'

export const RIDERS_UPDATE_MEMBERSHIPS_REQUEST = 'RIDERS_UPDATE_MEMBERSHIPS_REQUEST'
export const RIDERS_UPDATE_MEMBERSHIPS_SUCCESS = 'RIDERS_UPDATE_MEMBERSHIPS_SUCCESS'
export const RIDERS_UPDATE_MEMBERSHIPS_FAILURE = 'RIDERS_UPDATE_MEMBERSHIPS_FAILURE'

export const RIDERS_UPDATE_MOBILITIES_REQUEST = 'RIDERS_UPDATE_MOBILITIES_REQUEST'
export const RIDERS_UPDATE_MOBILITIES_SUCCESS = 'RIDERS_UPDATE_MOBILITIES_SUCCESS'
export const RIDERS_UPDATE_MOBILITIES_FAILURE = 'RIDERS_UPDATE_MOBILITIES_FAILURE'

export const RIDERS_ADD_FUNDS_TO_WALLET_REQUEST = 'RIDERS_ADD_FUNDS_TO_WALLET_REQUEST'
export const RIDERS_ADD_FUNDS_TO_WALLET_SUCCESS = 'RIDERS_ADD_FUNDS_TO_WALLET_SUCCESS'
export const RIDERS_ADD_FUNDS_TO_WALLET_FAILURE = 'RIDERS_ADD_FUNDS_TO_WALLET_FAILURE'

export const RIDERS_ADD_BONUS_TO_WALLET_REQUEST = 'RIDERS_ADD_BONUS_TO_WALLET_REQUEST'
export const RIDERS_ADD_BONUS_TO_WALLET_SUCCESS = 'RIDERS_ADD_BONUS_TO_WALLET_SUCCESS'
export const RIDERS_ADD_BONUS_TO_WALLET_FAILURE = 'RIDERS_ADD_BONUS_TO_WALLET_FAILURE'

export const RIDERS_RECHARGE_WALLET_REQUEST = 'RIDERS_RECHARGE_WALLET_REQUEST'
export const RIDERS_RECHARGE_WALLET_SUCCESS = 'RIDERS_RECHARGE_WALLET_SUCCESS'
export const RIDERS_RECHARGE_WALLET_FAILURE = 'RIDERS_ADD_FUNDS_TO_WALLET_FAILURE'

export const RIDERS_FETCH_WALLET_AUTOCHARGE_REQUEST = 'RIDERS_FETCH_WALLET_AUTOCHARGE_REQUEST'
export const RIDERS_FETCH_WALLET_AUTOCHARGE_SUCCESS = 'RIDERS_FETCH_WALLET_AUTOCHARGE_SUCCESS'
export const RIDERS_FETCH_WALLET_AUTOCHARGE_FAILURE = 'RIDERS_FETCH_WALLET_AUTOCHARGE_FAILURE'

export const RIDERS_UPDATE_WALLET_AUTOCHARGE_REQUEST = 'RIDERS_UPDATE_WALLET_AUTOCHARGE_REQUEST'
export const RIDERS_UPDATE_WALLET_AUTOCHARGE_SUCCESS = 'RIDERS_UPDATE_WALLET_AUTOCHARGE_SUCCESS'
export const RIDERS_UPDATE_WALLET_AUTOCHARGE_FAILURE = 'RIDERS_UPDATE_WALLET_AUTOCHARGE_FAILURE'

export const TRIP_AVAILABLE_PRODUCTS_REQUEST = 'TRIP_AVAILABLE_PRODUCTS_REQUEST'
export const TRIP_AVAILABLE_PRODUCTS_SUCCESS = 'TRIP_AVAILABLE_PRODUCTS_SUCCESS'
export const TRIP_AVAILABLE_PRODUCTS_FAILURE = 'TRIP_AVAILABLE_PRODUCTS_FAILURE'

export const TRIP_CANCEL_REQUEST = 'TRIP_CANCEL_REQUEST'
export const TRIP_CANCEL_SUCCESS = 'TRIP_CANCEL_SUCCESS'
export const TRIP_CANCEL_FAILURE = 'TRIP_CANCEL_FAILURE'

export const TRIP_NO_SHOW_REQUEST = 'TRIP_NO_SHOW_REQUEST'
export const TRIP_NO_SHOW_SUCCESS = 'TRIP_NO_SHOW_SUCCESS'
export const TRIP_NO_SHOW_FAILURE = 'TRIP_NO_SHOW_FAILURE'

export const TRIP_CREATE_REQUEST = 'TRIP_CREATE_REQUEST'
export const TRIP_CREATE_SUCCESS = 'TRIP_CREATE_SUCCESS'
export const TRIP_CREATE_FAILURE = 'TRIP_CREATE_FAILURE'

export const TRIP_CREATED_WITH_PCA_RIDER_SUCCESS_MESSAGE = 'TRIP_CREATED_WITH_PCA_RIDER_SUCCESS_MESSAGE'

export const INTEGRATION_FETCH_REQUEST = 'INTEGRATION_FETCH_REQUEST'
export const INTEGRATION_FETCH_SUCCESS = 'INTEGRATION_FETCH_SUCCESS'
export const INTEGRATION_FETCH_FAILURE = 'INTEGRATION_FETCH_FAILURE'

export const TRIP_GET_REQUEST = 'TRIP_GET_REQUEST'
export const TRIP_GET_SUCCESS = 'TRIP_GET_SUCCESS'
export const TRIP_GET_FAILURE = 'TRIP_GET_FAILURE'

export const TRIPS_HISTORY_REQUEST = 'TRIPS_HISTORY_REQUEST'
export const TRIPS_HISTORY_SUCCESS = 'TRIPS_HISTORY_SUCCESS'
export const TRIPS_HISTORY_FAILURE = 'TRIPS_HISTORY_FAILURE'

export const TRIPS_ORGANIZATION_REQUEST = 'TRIPS_ORGANIZATION_REQUEST'
export const TRIPS_ORGANIZATION_SUCCESS = 'TRIPS_ORGANIZATION_SUCCESS'
export const TRIPS_ORGANIZATION_FAILURE = 'TRIPS_ORGANIZATION_FAILURE'

export const TRIPS_HISTORY_UPDATE_COLUMNS = 'TRIPS_HISTORY_UPDATE_COLUMNS'
export const TRIP_HISTORY_REQUEST = 'TRIP_HISTORY_REQUEST'
export const TRIP_HISTORY_SUCCESS = 'TRIP_HISTORY_SUCCESS'
export const TRIP_HISTORY_FAILURE = 'TRIP_HISTORY_FAILURE'

export const TRIPS_FETCH_REQUEST = 'TRIPS_FETCH_REQUEST'
export const TRIPS_FETCH_SUCCESS = 'TRIPS_FETCH_SUCCESS'
export const TRIPS_FETCH_FAILURE = 'TRIPS_FETCH_FAILURE'
export const SET_TRIPS_EMPTY = 'SET_TRIPS_EMPTY'

export const GENERATE_RECURRING_TRIPS = 'GENERATE_RECURRING_TRIPS'

export const UPDATE_SINGLE_TRIP = 'UPDATE_SINGLE_TRIP'

export const TRIPS_SUMMARY_REQUEST = 'TRIPS_SUMMARY_REQUEST'
export const TRIPS_SUMMARY_SUCCESS = 'TRIPS_SUMMARY_SUCCESS'
export const TRIPS_SUMMARY_FAILURE = 'TRIPS_SUMMARY_FAILURE'

export const FEEDBACK_FETCH_REQUEST = 'FEEDBACK_FETCH_REQUEST'
export const FEEDBACK_FETCH_SUCCESS = 'FEEDBACK_FETCH_SUCCESS'
export const FEEDBACK_FETCH_FAILURE = 'FEEDBACK_FETCH_FAILURE'

export const RIDER_RECURRING_TRIPS_REQUEST = 'RIDER_RECURRING_TRIPS_REQUEST'
export const RIDER_RECURRING_TRIPS_SUCCESS = 'RIDER_RECURRING_TRIPS_SUCCESS'
export const RIDER_RECURRING_TRIPS_FAILURE = 'RIDER_RECURRING_TRIPS_FAILURE'

export const RIDER_CHANGE_LOG_REQUEST = 'RIDER_CHANGE_LOG_REQUEST'
export const RIDER_CHANGE_LOG_SUCCESS = 'RIDER_CHANGE_LOG_SUCCESS'
export const RIDER_CHANGE_LOG_FAILURE = 'RIDER_CHANGE_LOG_FAILURE'

export const DESTROY_RECURRING_TRIP_TASK_SUCCESS = 'DESTROY_RECURRING_TRIP_TASK_SUCCESS'
export const DESTROY_RECURRING_TRIP_TASK_FAIL = 'DESTROY_RECURRING_TRIP_TASK_FAIL'

export const GET_REFUNDED_AMOUNT_SUCCESS = 'GET_REFUNDED_AMOUNT_SUCCESS'
export const GET_REFUNDED_AMOUNT_FAILURE = 'GET_REFUNDED_AMOUNT_FAILURE'

export const REFUND_PAYMENT_SUCCESS = 'REFUND_PAYMENT_SUCCESS'
export const REFUND_PAYMENT_FAILURE = 'REFUND_PAYMENT_FAILURE'

export const ASSIGN_REFUND_DETAILS = 'ASSIGN_REFUND_DETAILS'

export const UPDATE_TRIP_SUCCESS = 'UPDATE_TRIP_SUCCESS'

export const SET_MAP_VIEW_STRATEGY_STAGE = 'SET_MAP_VIEW_STRATEGY_STAGE'

export const SET_ORIGIN_TO_TRIP_REQUEST = 'SET_ORIGIN_TO_TRIP_REQUEST'
export const SET_DESTINATION_TO_TRIP_REQUEST = 'SET_DESTINATION_TO_TRIP_REQUEST'
export const SET_ADDITIONAL_STOP_TO_TRIP_REQUEST = 'SET_ADDITIONAL_STOP_TO_TRIP_REQUEST'
export const CHANGE_ADDITIONAL_STOP_ORDER = 'CHANGE_ADDITIONAL_STOP_ORDER'
export const CHANGE_LOCATIONS_ORDER = 'CHANGE_LOCATIONS_ORDER'
export const REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST = 'REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST'
export const SET_ESTIMATES_TO_TRIP_REQUEST = 'SET_ESTIMATES_TO_TRIP_REQUEST'
export const SET_PICKUP_TIME_TO_TRIP_REQUEST = 'SET_PICKUP_TIME_TO_TRIP_REQUEST'
export const SET_LEAVE_AT_TIME_TO_TRIP_REQUEST = 'SET_LEAVE_AT_TIME_TO_TRIP_REQUEST'
export const SET_ARRIVE_BY_TIME_TO_TRIP_REQUEST = 'SET_ARRIVE_BY_TIME_TO_TRIP_REQUEST'
export const SET_DROPOFF_TIME_TO_TRIP_REQUEST = 'SET_DROPOFF_TIME_TO_TRIP_REQUEST'
export const SET_RECURRING_PICK_UP_TIME = 'SET_RECURRING_PICK_UP_TIME'
export const SET_RECURRING_DROP_OFF_TIME = 'SET_RECURRING_DROP_OFF_TIME'
export const SET_DROPOFF_PHONE_NUMBER = 'SET_DROPOFF_PHONE_NUMBER'
export const SET_PICKUP_PHONE_NUMBER = 'SET_PICKUP_PHONE_NUMBER'
export const SET_CRON_TAB_EXP = 'SET_CRON_TAB_EXP'
export const SET_RUN_FOREVER = 'SET_RUN_FOREVER'
export const SET_TIMES_TO_RECUR = 'SET_TIMES_TO_RECUR'
export const SET_TRIP_DOUBLE_CHECKER_ENABLE = 'SET_TRIP_DOUBLE_CHECKER_ENABLE'
export const SET_BOOK_DOUBLE_TRIP = 'SET_BOOK_DOUBLE_TRIP'
export const SET_DISTANCE_AND_DURATION_TO_TRIP_REQUEST = 'SET_DISTANCE_AND_DURATION_TO_TRIP_REQUEST'

export const TRIP_CLONE = 'TRIP_CLONE'
export const TRIP_LOCATION_SWAP = 'TRIP_LOCATION_SWAP'
export const RESET_SELECTED_TRIP_REQUEST_PRODUCT = 'RESET_SELECTED_TRIP_REQUEST_PRODUCT'
export const UPDATE_ADDITIONAL_STOP_SEQUENCE = 'UPDATE_ADDITIONAL_STOP_SEQUENCE'
export const UPDATE_LOCATION_SEQUENCE = 'UPDATE_LOCATION_SEQUENCE'

export const FEEDBACK_STATUS_UPDATE_REQUEST = 'FEEDBACK_STATUS_UPDATE_REQUEST'
export const FEEDBACK_STATUS_UPDATE_SUCCESS = 'FEEDBACK_STATUS_UPDATE_SUCCESS'
export const FEEDBACK_STATUS_UPDATE_FAILURE = 'FEEDBACK_STATUS_UPDATE_FAILURE'

export const CREATE_TRIP_FAIL = 'CREATE_TRIP_FAIL'

// ROUTE OPTIMIZATION
export const ROUTE_OPTIMIZATION_REQUEST = 'ROUTE_OPTIMIZATION_REQUEST'
export const ROUTE_OPTIMIZATION_SUCCESS = 'ROUTE_OPTIMIZATION_SUCCESS'
export const ROUTE_OPTIMIZATION_FAILURE = 'ROUTE_OPTIMIZATION_FAILURE'

export const OPTIMIZE_TRIP_REQUEST = 'OPTIMIZE_TRIP_REQUEST'
export const OPTIMIZE_TRIP_SUCCESS = 'OPTIMIZE_TRIP_SUCCESS'
export const OPTIMIZE_TRIP_FAILURE = 'OPTIMIZE_TRIP_FAILURE'

export const GROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST = 'GROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST'
export const GROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE = 'GROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE'
export const GROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE = 'GROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE'

export const MANUAL_GROUP_TRIPS_REQUEST = 'MANUAL_GROUP_TRIPS_REQUEST'
export const MANUAL_GROUP_TRIPS_SUCCESS = 'MANUAL_GROUP_TRIPS_SUCCESS'
export const MANUAL_GROUP_TRIPS_FAILURE = 'MANUAL_GROUP_TRIPS_FAILURE'

export const UNGROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST = 'UNGROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST'
export const UNGROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE = 'UNGROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE'
export const UNGROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE = 'UNGROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE'

export const GET_TEMPORARY_VEHICLES_REQUEST = 'GET_TEMPORARY_VEHICLES_REQUEST'
export const GET_TEMPORARY_VEHICLES_SUCCESS = 'GET_TEMPORARY_VEHICLES_SUCCESS'
export const GET_TEMPORARY_VEHICLES_FAILURE = 'GET_TEMPORARY_VEHICLES_FAILURE'

export const GET_TEMP_VEHICLE_TRIPS_COUNT_REQUEST = 'GET_TEMP_VEHICLE_TRIPS_COUNT_REQUEST'
export const GET_TEMP_VEHICLE_TRIPS_COUNT_SUCCESS = 'GET_TEMP_VEHICLE_TRIPS_COUNT_SUCCESS'
export const GET_TEMP_VEHICLE_TRIPS_COUNT_FAILURE = 'GET_TEMP_VEHICLE_TRIPS_COUNT_FAILURE'

export const GET_SCHEDULED_REQUESTED_TRIPS_REQUEST = 'GET_SCHEDULED_REQUESTED_TRIPS_REQUEST'
export const GET_SCHEDULED_REQUESTED_TRIPS_SUCCESS = 'GET_SCHEDULED_REQUESTED_TRIPS_SUCCESS'
export const GET_SCHEDULED_REQUESTED_TRIPS_FAILURE = 'GET_SCHEDULED_REQUESTED_TRIPS_FAILURE'

export const GET_TEMPVEHICLES_PER_SERVICE_REQUEST = 'GET_TEMPVEHICLES_PER_SERVICE_REQUEST'
export const GET_TEMPVEHICLES_PER_SERVICE_SUCCESS = 'GET_TEMPVEHICLES_PER_SERVICE_SUCCESS'
export const GET_TEMPVEHICLES_PER_SERVICE_FAILURE = 'GET_TEMPVEHICLES_PER_SERVICE_FAILURE'

export enum TRIPS_HISTORY_COLUMNS {
  DATE = 'Date',
  PICKUP_TIME = 'Pick-Up Time',
  ARRIVAL_TIME = 'Arrival Time',
  STATUS = 'Status',
  RIDER_NAME = 'Rider Name',
  PROVIDER = 'Provider',
  SERVICE = 'Service',
  COST = 'Cost',
  FARE = 'Fare'
}

export enum TRIPS_HISTORY_DETAILS_TABS {
  TRIP_DETAILS = 'TRIP DETAILS',
  AUDIT_LOG = 'AUDIT LOG'
}

export const RIDERS_DETAILS_SUSPEND_MEMBERSHIP_REQUEST = 'RIDERS_DETAILS_SUSPEND_MEMBERSHIP_REQUEST'
export type RIDERS_DETAILS_SUSPEND_MEMBERSHIP_REQUEST = typeof RIDERS_DETAILS_SUSPEND_MEMBERSHIP_REQUEST

export const RIDERS_DETAILS_SUSPEND_MEMBERSHIP_SUCCESS = 'RIDERS_DETAILS_SUSPEND_MEMBERSHIP_SUCCESS'
export type RIDERS_DETAILS_SUSPEND_MEMBERSHIP_SUCCESS = typeof RIDERS_DETAILS_SUSPEND_MEMBERSHIP_SUCCESS

export const RIDERS_DETAILS_SUSPEND_MEMBERSHIP_FAILURE = 'RIDERS_DETAILS_SUSPEND_MEMBERSHIP_FAILURE'
export type RIDERS_DETAILS_SUSPEND_MEMBERSHIP_FAILURE = typeof RIDERS_DETAILS_SUSPEND_MEMBERSHIP_FAILURE

/* ---------------- LOCATION CONSTANTS ---------------- */

export const PICKUP_AUTO_COMPLETE = 'PICKUP_AUTO_COMPLETE'
export type PICKUP_AUTO_COMPLETE = typeof PICKUP_AUTO_COMPLETE

export const DROPOFF_AUTO_COMPLETE = 'DROPOFF_AUTO_COMPLETE'
export type DROPOFF_AUTO_COMPLETE = typeof DROPOFF_AUTO_COMPLETE

export const ADDITIONAL_STOP_AUTO_COMPLETE = 'ADDITIONAL_STOP_AUTO_COMPLETE'
export type ADDITIONAL_STOP_AUTO_COMPLETE = typeof ADDITIONAL_STOP_AUTO_COMPLETE

export const CLEAR_AUTO_COMPLETE = 'CLEAR_AUTO_COMPLETE'
export type CLEAR_AUTO_COMPLETE = typeof CLEAR_AUTO_COMPLETE

export const SET_QUERY = 'SET_QUERY'
export type SET_QUERY = typeof SET_QUERY

export const CLEAR_LOCATION_SEARCH = 'CLEAR_LOCATION_SEARCH'
export type CLEAR_LOCATION_SEARCH = typeof CLEAR_LOCATION_SEARCH

export const SEARCH_LOCATION_REQUEST = 'SEARCH_LOCATION_REQUEST'
export type SEARCH_LOCATION_REQUEST = typeof SEARCH_LOCATION_REQUEST

export const SEARCH_LOCATION_SUCCESS = 'SEARCH_LOCATION_SUCCESS'
export type SEARCH_LOCATION_SUCCESS = typeof SEARCH_LOCATION_SUCCESS

export const SEARCH_LOCATION_FAIL = 'SEARCH_LOCATION_FAIL'
export type SEARCH_LOCATION_FAIL = typeof SEARCH_LOCATION_FAIL

export const SELECT_LOCATION_REQUEST = 'SELECT_LOCATION_REQUEST'
export type SELECT_LOCATION_REQUEST = typeof SELECT_LOCATION_REQUEST

export const SELECT_LOCATION_SUCCESS = 'SELECT_LOCATION_SUCCESS'
export type SELECT_LOCATION_SUCCESS = typeof SELECT_LOCATION_SUCCESS

export const SELECT_LOCATION_FAIL = 'SELECT_LOCATION_FAIL'
export type SELECT_LOCATION_FAIL = typeof SELECT_LOCATION_FAIL

export const SELECT_PROVIDER_PRODUCT = 'SELECT_PROVIDER_PRODUCT'
export type SELECT_PROVIDER_PRODUCT = typeof SELECT_PROVIDER_PRODUCT

export const SELECT_SERVICE_ID = 'SELECT_SERVICE_ID'
export type SELECT_SERVICE_ID = typeof SELECT_SERVICE_ID

export const ASSISTANCE_REQUEST = 'ASSISTANCE_REQUEST'
export type ASSISTANCE_REQUEST = typeof ASSISTANCE_REQUEST

export const ASSISTANCE_SUCCESS = 'ASSISTANCE_SUCCESS'
export type ASSISTANCE_SUCCESS = typeof ASSISTANCE_SUCCESS

export const ASSISTANCE_FAIL = 'ASSISTANCE_FAIL'
export type ASSISTANCE_FAIL = typeof ASSISTANCE_FAIL

export const TRIP_PROVIDERS_REQUEST = 'TRIP_PROVIDERS_REQUEST'
export type TRIP_PROVIDERS_REQUEST = typeof TRIP_PROVIDERS_REQUEST

export const TRIP_PROVIDERS_SUCCESS = 'TRIP_PROVIDERS_SUCCESS'
export type TRIP_PROVIDERS_SUCCESS = typeof TRIP_PROVIDERS_SUCCESS

export const TRIP_PROVIDERS_FAIL = 'TRIP_PROVIDERS_FAIL'
export type TRIP_PROVIDERS_FAIL = typeof TRIP_PROVIDERS_FAIL

export const SELECT_PROVIDER_REQUEST = 'SELECT_PROVIDER_REQUEST'

export const SELECT_PROVIDER_SUCCESS = 'SELECT_PROVIDER_SUCCESS'

export const SELECT_PROVIDER_FAIL = 'SELECT_PROVIDER_FAIL'

export const SET_TRIP_SETTINGS = 'SET_TRIP_SETTINGS'

/* ---------------- PROVIDER CONSTANTS ---------------- */
export const PROVIDER_SUCCESS = 'PROVIDER_SUCCESS'
export const PROVIDER_FAIL = 'PROVIDER_FAIL'
export const SET_CURRENT_PROVIDER_ID = 'SET_CURRENT_PROVIDER_ID'

export const PROVIDER_GET_REQUEST = 'PROVIDER_GET_REQUEST'
export const PROVIDER_GET_SUCCESS = 'PROVIDER_GET_SUCCESS'
export const PROVIDER_GET_FAIL = 'PROVIDER_GET_FAIL'

export const PROVIDER_LIST_REQUEST = 'PROVIDER_LIST_REQUEST'
export const PROVIDER_LIST_SUCCESS = 'PROVIDER_LIST_SUCCESS'
export const PROVIDER_LIST_FAIL = 'PROVIDER_LIST_FAIL'

export const PROVIDER_SAVE_REQUEST = 'PROVIDER_SAVE_REQUEST'
export const PROVIDER_SAVE_SUCCESS = 'PROVIDER_SAVE_SUCCESS'
export const PROVIDER_SAVE_FAIL = 'PROVIDER_SAVE_FAIL'

export const PROVIDER_CREATE_REQUEST = 'PROVIDER_CREATE_REQUEST'
export const PROVIDER_CREATE_SUCCESS = 'PROVIDER_CREATE_SUCCESS'
export const PROVIDER_CREATE_FAIL = 'PROVIDER_CREATE_FAIL'

export const PROVIDER_REMOVE_REQUEST = 'PROVIDER_REMOVE_REQUEST'
export const PROVIDER_REMOVE_SUCCESS = 'PROVIDER_REMOVE_SUCCESS'
export const PROVIDER_REMOVE_FAIL = 'PROVIDER_REMOVE_FAIL'

export const PROVIDER_FILTER = 'PROVIDER_FILTER'
export const PROVIDER_UPDATE = 'PROVIDER_UPDATE'
export const PROVIDER_DELETE_MODAL_SHOW = 'PROVIDER_DELETE_MODAL_SHOW'
export const PROVIDER_DELETE_MODAL_HIDE = 'PROVIDER_DELETE_MODAL_HIDE'

/* ---------------- PROVIDER PRODUCT CONSTANTS ---------------- */

export const SET_CURRENT_PRODUCT_IDS = 'SET_CURRENT_PRODUCT_IDS'
export const PRODUCT_FILTER = 'PRODUCT_FILTER'

export const PRODUCT_FETCH_REQUEST = 'PRODUCT_FETCH_REQUEST'
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS'
export const PRODUCT_FETCH_FAIL = 'PRODUCT_FETCH_FAIL'

export const PROVIDER_PRODUCT_LIST_FAIL = 'PROVIDER_PRODUCT_LIST_FAIL'
export const PROVIDER_PRODUCT_LIST_REQUEST = 'PROVIDER_PRODUCT_LIST_REQUEST'
export const PROVIDER_PRODUCT_LIST_SUCCESS = 'PROVIDER_PRODUCT_LIST_SUCCESS'
export const PROVIDER_PRODUCT_LIST_SUCCESS_COUNT = 'PROVIDER_PRODUCT_LIST_SUCCESS_COUNT'

export const PROVIDER_PRODUCT_SAVE_FAIL = 'PROVIDER_PRODUCT_SAVE_FAIL'
export const PROVIDER_PRODUCT_SAVE_REQUEST = 'PROVIDER_PRODUCT_SAVE_REQUEST'
export const PROVIDER_PRODUCT_SAVE_SUCCESS = 'PROVIDER_PRODUCT_SAVE_SUCCESS'

export const UPDATE_PRODUCT_FILTERS = 'UPDATE_PRODUCT_FILTERS'
export const PROVIDER_PRODUCT_UPDATE = 'PROVIDER_PRODUCT_UPDATE'
export const PROVIDER_PRODUCT_REMOVE_REQUEST = 'PROVIDER_PRODUCT_REMOVE_REQUEST'
export const PROVIDER_PRODUCT_REMOVE_SUCCESS = 'PROVIDER_PRODUCT_REMOVE_SUCCESS'
export const PROVIDER_PRODUCT_REMOVE_FAIL = 'PROVIDER_PRODUCT_REMOVE_FAIL'
export const PROVIDER_PRODUCT_ACTIVATE_REQUEST = 'PROVIDER_PRODUCT_ACTIVATE_REQUEST'
export const PROVIDER_PRODUCT_ACTIVATE_SUCCESS = 'PROVIDER_PRODUCT_ACTIVATE_SUCCESS'
export const PROVIDER_PRODUCT_ACTIVATE_FAIL = 'PROVIDER_PRODUCT_REMOVE_FAIL'
export const PROVIDER_PRODUCT_DEACTIVATE_REQUEST = 'PROVIDER_PRODUCT_DEACTIVATE_REQUEST'
export const PROVIDER_PRODUCT_DEACTIVATE_SUCCESS = 'PROVIDER_PRODUCT_DEACTIVATE_SUCCESS'
export const PROVIDER_PRODUCT_DEACTIVATE_FAIL = 'PROVIDER_PRODUCT_DEACTIVATE_FAIL'
export const PROVIDER_PRODUCT_DEACTIVATE_MODAL_SHOW = 'PROVIDER_PRODUCT_DEACTIVATE_MODAL_SHOW'
export const PROVIDER_PRODUCT_DEACTIVATE_MODAL_HIDE = 'PROVIDER_PRODUCT_DEACTIVATE_MODAL_HIDE'
export const PROVIDER_PRODUCT_CREATE_FAIL = 'PROVIDER_PRODUCT_CREATE_FAIL'
export const PROVIDER_PRODUCT_CREATE_REQUEST = 'PROVIDER_PRODUCT_CREATE_REQUEST'
export const PROVIDER_PRODUCT_CREATE_SUCCESS = 'PROVIDER_PRODUCT_CREATE_SUCCESS'
export const PROVIDER_PRODUCT_DELETE_MODAL_SHOW = 'PROVIDER_PRODUCT_DELETE_MODAL_SHOW'
export const PROVIDER_PRODUCT_DELETE_MODAL_HIDE = 'PROVIDER_PRODUCT_DELETE_MODAL_HIDE'
export const PROVIDER_PRODUCT_ACTIVATE_MODAL_SHOW = 'PROVIDER_PRODUCT_ACTIVATE_MODAL_SHOW'
export const PROVIDER_PRODUCT_ACTIVATE_MODAL_HIDE = 'PROVIDER_PRODUCT_ACTIVATE_MODAL_HIDE'

/* ---------------- ORG CONSTANTS ---------------- */
export const ORG_SELECT = 'ORG_SELECT'
export type ORG_SELECT = typeof ORG_SELECT

/* ---------------- GOOGLE_MAP CONSTANTS ---------------- */
export const SET_MARKER = 'SET_MARKER'
export const SET_ORIGIN = 'SET_ORIGIN'
export const SET_DESTINATION = 'SET_DESTINATION'
export const SET_ADDITIONAL_STOP = 'SET_ADDITIONAL_STOP'
export const REMOVE_ADDITIONAL_STOP = 'REMOVE_ADDITIONAL_STOP'
export const SET_OPERATOR_LOCATION = 'SET_OPERATOR_LOCATION'
export const SET_CENTER = 'SET_CENTER'
export const SET_ZOOM = 'SET_ZOOM'
export const ADD_MARKERS = 'ADD_MARKERS'
export const REPLACE_MARKERS = 'REPLACE_MARKERS'
export const REMOVE_MARKER = 'REMOVE_MARKER'
export const CLEAR_MARKERS = 'CLEAR_MARKERS'
export const SET_POLYLINE = 'SET_POLYLINE'
export const SET_POLYGON = 'SET_POLYGON'
export const SET_MAP_ZONE = 'SET_MAP_ZONE'
export const SET_BOUNDS = 'SET_BOUNDS'
export const SET_INIT_CENTER = 'SET_INIT_CENTER'

/* ---------------- TEAM MEMBERS CONSTANTS ---------------- */
export const TEAM_MEMBER_LIST_REQUEST = 'TEAM_MEMBER_LIST_REQUEST'
export const TEAM_MEMBER_LIST_SUCCESS = 'TEAM_MEMBER_LIST_SUCCESS'
export const TEAM_MEMBER_LIST_FAIL = 'TEAM_MEMBER_LIST_FAIL'

export const TEAM_MEMBER_INVITE_REQUEST = 'TEAM_MEMBER_INVITE_REQUEST'
export const TEAM_MEMBER_INVITE_SUCCESS = 'TEAM_MEMBER_INVITE_SUCCESS'
export const TEAM_MEMBER_INVITE_FAIL = 'TEAM_MEMBER_INVITE_FAIL'

export const TEAM_MEMBER_FETCH_REQUEST = 'TEAM_MEMBER_FETCH_REQUEST'
export const TEAM_MEMBER_FETCH_SUCCESS = 'TEAM_MEMBER_FETCH_SUCCESS'
export const TEAM_MEMBER_FETCH_FAIL = 'TEAM_MEMBER_FETCH_FAIL'

export const TEAM_MEMBER_UPDATE_REQUEST = 'TEAM_MEMBER_UPDATE_REQUEST'
export const TEAM_MEMBER_UPDATE_SUCCESS = 'TEAM_MEMBER_UPDATE_SUCCESS'
export const TEAM_MEMBER_UPDATE_FAIL = 'TEAM_MEMBER_UPDATE_FAIL'

export const TEAM_MEMBER_ARCHIVE_REQUEST = 'TEAM_MEMBER_ARCHIVE_REQUEST'
export const TEAM_MEMBER_ARCHIVE_SUCCESS = 'TEAM_MEMBER_ARCHIVE_SUCCESS'
export const TEAM_MEMBER_ARCHIVE_FAIL = 'TEAM_MEMBER_ARCHIVE_FAIL'

export const TEAM_MEMBER_RESTORE_REQUEST = 'TEAM_MEMBER_RESTORE_REQUEST'
export const TEAM_MEMBER_RESTORE_SUCCESS = 'TEAM_MEMBER_RESTORE_SUCCESS'
export const TEAM_MEMBER_RESTORE_FAIL = 'TEAM_MEMBER_RESTORE_FAIL'

export const TEAM_MEMBER_PERMISSION_FETCH_REQUEST = 'TEAM_MEMBER_PERMISSION_FETCH_REQUEST'
export const TEAM_MEMBER_PERMISSION_FETCH_SUCCESS = 'TEAM_MEMBER_PERMISSION_FETCH_SUCCESS'
export const TEAM_MEMBER_PERMISSION_FETCH_FAIL = 'TEAM_MEMBER_PERMISSION_FETCH_FAIL'

export const TEAM_MEMBER_PERMISSION_UPDATE_REQUEST = 'TEAM_MEMBER_PERMISSION_UPDATE_REQUEST'
export const TEAM_MEMBER_PERMISSION_UPDATE_SUCCESS = 'TEAM_MEMBER_PERMISSION_UPDATE_SUCCESS'
export const TEAM_MEMBER_PERMISSION_UPDATE_FAIL = 'TEAM_MEMBER_PERMISSION_UPDATE_FAIL'

export const TEAM_MEMBER_PERMISSION_CREATE_REQUEST = 'TEAM_MEMBER_PERMISSION_CREATE_REQUEST'
export const TEAM_MEMBER_PERMISSION_CREATE_SUCCESS = 'TEAM_MEMBER_PERMISSION_CREATE_SUCCESS'
export const TEAM_MEMBER_PERMISSION_CREATE_FAIL = 'TEAM_MEMBER_PERMISSION_CREATE_FAIL'

export const SET_CURRENT_TEAM_MEMBER_PERMISSION = 'SET_CURRENT_TEAM_MEMBER_PERMISSION'

export const TEAM_MEMBER_STATUS_ACTIVE = 'Active'
export const TEAM_MEMBER_STATUS_NOT_ACCEPTED = 'Not accepted'

export const TEAM_MEMBER_ROLES = {
  admin: 'Admin',
  customerService: 'Customer Service',
  billingAdmin: 'Billing Admin'
}
/* ---------------- STATION USER CONSTANTS ---------------- */

export const STATION_USER_LIST_REQUEST = 'STATION_USER_LIST_REQUEST'
export const STATION_USER_LIST_SUCCESS = 'STATION_USER_LIST_SUCCESS'
export const STATION_USER_LIST_FAIL = 'STATION_USER_LIST_FAIL'

export const STATION_USER_FETCH_REQUEST = 'STATION_USER_FETCH_REQUEST'
export const STATION_USER_FETCH_SUCCESS = 'STATION_USER_FETCH_SUCCESS'
export const STATION_USER_FETCH_FAIL = 'STATION_USER_FETCH_FAIL'

export const STATION_USER_UPDATE_REQUEST = 'STATION_USER_UPDATE_REQUEST'
export const STATION_USER_UPDATE_SUCCESS = 'STATION_USER_UPDATE_SUCCESS'
export const STATION_USER_UPDATE_FAIL = 'STATION_USER_UPDATE_FAIL'

export const CREATE_STATION_USER_REQUEST = 'CREATE_STATION_USER_REQUEST'
export const CREATE_STATION_USER_SUCCESS = 'CREATE_STATION_USER_SUCCESS'
export const CREATE_STATION_USER_FAIL = 'CREATE_STATION_USER_FAIL'

export const STATION_USER_ARCHIVE_REQUEST = 'STATION_USER_ARCHIVE_REQUEST'
export const STATION_USER_ARCHIVE_SUCCESS = 'STATION_USER_ARCHIVE_SUCCESS'
export const STATION_USER_ARCHIVE_FAIL = 'STATION_USER_ARCHIVE_FAIL'

export const STATION_USER_RESTORE_REQUEST = 'STATION_USER_RESTORE_REQUEST'
export const STATION_USER_RESTORE_SUCCESS = 'STATION_USER_RESTORE_SUCCESS'
export const STATION_USER_RESTORE_FAIL = 'STATION_USER_RESTORE_FAIL'

export const STATION_USER_GET_GOINZONE_REQUEST = 'STATION_USER_GET_GOINZONE_REQUEST'
export const STATION_USER_GET_GOINZONE_SUCCESS = 'STATION_USER_GET_GOINZONE_SUCCESS'
export const STATION_USER_GET_GOINZONE_FAIL = 'STATION_USER_GET_GOINZONE_FAIL'

export const STATION_USER_EDIT_SET_FETCHING = 'STATION_USER_EDIT_SET_FETCHING'

/* ---------------- STATION USER TRIPS CONSTANTS ---------------- */

export const STATION_USER_TRIPS_FETCH_REQUEST = 'STATION_USER_TRIPS_FETCH_REQUEST'
export const STATION_USER_TRIPS_FETCH_SUCCESS = 'STATION_USER_TRIPS_FETCH_SUCCESS'

/* ---------------- Membership constants ---------------- */

export const MEMBERSHIP_LIST_REQUEST = 'MEMBERSHIP_LIST_REQUEST'
export type MEMBERSHIP_LIST_REQUEST = typeof MEMBERSHIP_LIST_REQUEST

export const MEMBERSHIP_LIST_SUCCESS = 'MEMBERSHIP_LIST_SUCCESS'
export type MEMBERSHIP_LIST_SUCCESS = typeof MEMBERSHIP_LIST_SUCCESS

export const MEMBERSHIP_LIST_FAILURE = 'MEMBERSHIP_LIST_FAILURE'
export type MEMBERSHIP_LIST_FAILURE = typeof MEMBERSHIP_LIST_FAILURE

export const MEMBERSHIP_REQUEST = 'MEMBERSHIP_REQUEST'

export const MEMBERSHIP_SUCCESS = 'MEMBERSHIP_SUCCESS'

export const MEMBERSHIP_FAIL = 'MEMBERSHIP_FAIL'

export const TOGGLE_MEMBERSHIP_MODAL = 'TOGGLE_MEMBERSHIP_MODAL'

export const SET_SELECTED_MEMBERSHIP = 'SET_SELECTED_MEMBERSHIP'

export const PERMANENT = 'PERMANENT'

export const TEMPORARY = 'TEMPORARY'

export const REJECT = 'REJECT'

export const EXPIRATION_DATE = 'EXPIRATION_DATE'

export const RECURRING = 'RECURRING'

export const NUMBER_OF_RIDES = 'NUMBER_OF_RIDES'

export const LIMITED_TIME = 'LIMITED_TIME'

export const MEMBERSHIPSUCCES_UPDATING_STATUS = 'MEMBERSHIPSUCCES_UPDATING_STATUS'

export const MEMBERSHIPSUCCES_UPDATE_STATUS = 'MEMBERSHIPSUCCES_UPDATE_STATUS'

/* ---------------- TRIPS STATUSES CONSTANTS ---------------- */

export const REQUESTING = 'REQUESTING'

export const WAITING_FOR_PICKUP = 'WAITING_FOR_PICKUP'

export const EN_ROUTE = 'EN_ROUTE'

export const SCHEDULED_TRIPS = 'SCHEDULED_TRIPS'

/* ---------------- MOBILITY OPTIONS CONSTANTS ---------------- */

export const MOBILITY_OPTIONS_LIST_REQUEST = 'MOBILITY_OPTIONS_LIST_REQUEST'
export type MOBILITY_OPTIONS_LIST_REQUEST = typeof MOBILITY_OPTIONS_LIST_REQUEST

export const MOBILITY_OPTIONS_LIST_FAIL = 'MOBILITY_OPTIONS_LIST_FAIL'
export type MOBILITY_OPTIONS_LIST_FAIL = typeof MOBILITY_OPTIONS_LIST_FAIL

export const MOBILITY_OPTIONS_LIST_SUCCESS = 'MOBILITY_OPTIONS_LIST_SUCCESS'
export type MOBILITY_OPTIONS_LIST_SUCCESS = typeof MOBILITY_OPTIONS_LIST_SUCCESS

export const MOBILITY_OPTIONS_SEARCH_REQUEST = 'MOBILITY_OPTIONS_SEARCH_REQUEST'
export type MOBILITY_OPTIONS_SEARCH_REQUEST = typeof MOBILITY_OPTIONS_SEARCH_REQUEST

export const MOBILITY_OPTIONS_SEARCH_SUCCESS = 'MOBILITY_OPTIONS_SEARCH_SUCCESS'
export type MOBILITY_OPTIONS_SEARCH_SUCCESS = typeof MOBILITY_OPTIONS_SEARCH_SUCCESS

export const MOBILITY_OPTIONS_SEARCH_FAILURE = 'MOBILITY_OPTIONS_SEARCH_FAILURE'
export type MOBILITY_OPTIONS_SEARCH_FAILURE = typeof MOBILITY_OPTIONS_SEARCH_FAILURE

export const CLEAR_MOBILITY_OPTIONS_SEARCH = 'CLEAR_MOBILITY_OPTIONS_SEARCH'
export type CLEAR_MOBILITY_OPTIONS_SEARCH = typeof CLEAR_MOBILITY_OPTIONS_SEARCH

export const MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST = 'MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST'
export type MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST = typeof MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST

export const MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE = 'MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE'
export type MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE = typeof MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE

export const MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS = 'MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS'
export type MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS = typeof MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS

export const MOBILITY_OPTIONS_CREATE_REQUEST = 'MOBILITY_OPTIONS_CREATE_REQUEST'
export type MOBILITY_OPTIONS_CREATE_REQUEST = typeof MOBILITY_OPTIONS_CREATE_REQUEST

export const MOBILITY_OPTIONS_CREATE_SUCCESS = 'MOBILITY_OPTIONS_CREATE_SUCCESS'
export type MOBILITY_OPTIONS_CREATE_SUCCESS = typeof MOBILITY_OPTIONS_CREATE_SUCCESS

export const MOBILITY_OPTIONS_CREATE_FAILURE = 'MOBILITY_OPTIONS_CREATE_FAILURE'
export type MOBILITY_OPTIONS_CREATE_FAILURE = typeof MOBILITY_OPTIONS_CREATE_FAILURE

export const MOBILITY_OPTIONS_UPDATE_REQUEST = 'MOBILITY_OPTIONS_UPDATE_REQUEST'
export type MOBILITY_OPTIONS_UPDATE_REQUEST = typeof MOBILITY_OPTIONS_UPDATE_REQUEST

export const MOBILITY_OPTIONS_UPDATE_SUCCESS = 'MOBILITY_OPTIONS_UPDATE_SUCCESS'
export type MOBILITY_OPTIONS_UPDATE_SUCCESS = typeof MOBILITY_OPTIONS_UPDATE_SUCCESS

export const MOBILITY_OPTIONS_UPDATE_FAILURE = 'MOBILITY_OPTIONS_UPDATE_FAILURE'
export type MOBILITY_OPTIONS_UPDATE_FAILURE = typeof MOBILITY_OPTIONS_UPDATE_FAILURE

export const MOBILITY_OPTIONS_REMOVE_REQUEST = 'MOBILITY_OPTIONS_REMOVE_REQUEST'
export type MOBILITY_OPTIONS_REMOVE_REQUEST = typeof MOBILITY_OPTIONS_REMOVE_REQUEST

export const MOBILITY_OPTIONS_REMOVE_SUCCESS = 'MOBILITY_OPTIONS_REMOVE_SUCCESS'
export type MOBILITY_OPTIONS_REMOVE_SUCCESS = typeof MOBILITY_OPTIONS_REMOVE_SUCCESS

export const MOBILITY_OPTIONS_REMOVE_FAILURE = 'MOBILITY_OPTIONS_REMOVE_FAILURE'
export type MOBILITY_OPTIONS_REMOVE_FAILURE = typeof MOBILITY_OPTIONS_REMOVE_FAILURE

export const MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST = 'MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST'
export type MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST = typeof MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST

export const MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS = 'MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS'
export type MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS = typeof MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS

export const MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE = 'MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE'
export type MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE = typeof MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE

export const MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST = 'MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST'
export type MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST = typeof MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST

export const MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS = 'MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS'
export type MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS = typeof MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS

export const MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE = 'MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE'
export type MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE = typeof MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE

/* ---------------- ASSISTANCE CONSTANTS ---------------- */

export const ASSISTANCE_LIST_REQUEST = 'ASSISTANCE_LIST_REQUEST'
export type ASSISTANCE_LIST_REQUEST = typeof ASSISTANCE_LIST_REQUEST

export const ASSISTANCE_LIST_FAILURE = 'ASSISTANCE_LIST_FAILURE'
export type ASSISTANCE_LIST_FAILURE = typeof ASSISTANCE_LIST_FAILURE

export const ASSISTANCE_LIST_SUCCESS = 'ASSISTANCE_LIST_SUCCESS'
export type ASSISTANCE_LIST_SUCCESS = typeof ASSISTANCE_LIST_SUCCESS

export const ASSISTANCE_CREATE_REQUEST = 'ASSISTANCE_CREATE_REQUEST'
export type ASSISTANCE_CREATE_REQUEST = typeof ASSISTANCE_CREATE_REQUEST

export const ASSISTANCE_CREATE_FAILURE = 'ASSISTANCE_CREATE_FAILURE'
export type ASSISTANCE_CREATE_FAILURE = typeof ASSISTANCE_CREATE_FAILURE

export const ASSISTANCE_CREATE_SUCCESS = 'ASSISTANCE_CREATE_SUCCESS'
export type ASSISTANCE_CREATE_SUCCESS = typeof ASSISTANCE_CREATE_SUCCESS

export const ASSISTANCE_UPDATE_REQUEST = 'ASSISTANCE_UPDATE_REQUEST'
export type ASSISTANCE_UPDATE_REQUEST = typeof ASSISTANCE_UPDATE_REQUEST

export const ASSISTANCE_UPDATE_FAILURE = 'ASSISTANCE_UPDATE_FAILURE'
export type ASSISTANCE_UPDATE_FAILURE = typeof ASSISTANCE_UPDATE_FAILURE

export const ASSISTANCE_UPDATE_SUCCESS = 'ASSISTANCE_UPDATE_SUCCESS'
export type ASSISTANCE_UPDATE_SUCCESS = typeof ASSISTANCE_UPDATE_SUCCESS

export const ASSISTANCE_REMOVE_REQUEST = 'ASSISTANCE_REMOVE_REQUEST'
export type ASSISTANCE_REMOVE_REQUEST = typeof ASSISTANCE_REMOVE_REQUEST

export const ASSISTANCE_REMOVE_FAILURE = 'ASSISTANCE_REMOVE_FAILURE'
export type ASSISTANCE_REMOVE_FAILURE = typeof ASSISTANCE_REMOVE_FAILURE

export const ASSISTANCE_REMOVE_SUCCESS = 'ASSISTANCE_REMOVE_SUCCESS'
export type ASSISTANCE_REMOVE_SUCCESS = typeof ASSISTANCE_REMOVE_SUCCESS

export const ASSISTANCE_CATEGORY_LIST_REQUEST = 'ASSISTANCE_CATEGORY_LIST_REQUEST'
export type ASSISTANCE_CATEGORY_LIST_REQUEST = typeof ASSISTANCE_CATEGORY_LIST_REQUEST

export const ASSISTANCE_CATEGORY_LIST_FAILURE = 'ASSISTANCE_CATEGORY_LIST_FAILURE'
export type ASSISTANCE_CATEGORY_LIST_FAILURE = typeof ASSISTANCE_CATEGORY_LIST_FAILURE

export const ASSISTANCE_CATEGORY_LIST_SUCCESS = 'ASSISTANCE_CATEGORY_LIST_SUCCESS'
export type ASSISTANCE_CATEGORY_LIST_SUCCESS = typeof ASSISTANCE_CATEGORY_LIST_SUCCESS

export const ASSISTANCE_SEARCH_REQUEST = 'ASSISTANCE_SEARCH_REQUEST'
export type ASSISTANCE_SEARCH_REQUEST = typeof ASSISTANCE_SEARCH_REQUEST

export const ASSISTANCE_SEARCH_SUCCESS = 'ASSISTANCE_SEARCH_SUCCESS'
export type ASSISTANCE_SEARCH_SUCCESS = typeof ASSISTANCE_SEARCH_SUCCESS

export const ASSISTANCE_SEARCH_FAILURE = 'ASSISTANCE_SEARCH_FAILURE'
export type ASSISTANCE_SEARCH_FAILURE = typeof ASSISTANCE_SEARCH_FAILURE

export const CLEAR_ASSISTANCE_SEARCH = 'CLEAR_ASSISTANCE_SEARCH'
export type CLEAR_ASSISTANCE_SEARCH = typeof CLEAR_ASSISTANCE_SEARCH

export const ASSISTANCE_CATEGORY_CREATE_REQUEST = 'ASSISTANCE_CATEGORY_CREATE_REQUEST'
export type ASSISTANCE_CATEGORY_CREATE_REQUEST = typeof ASSISTANCE_CATEGORY_CREATE_REQUEST

export const ASSISTANCE_CATEGORY_CREATE_SUCCESS = 'ASSISTANCE_CATEGORY_CREATE_SUCCESS'
export type ASSISTANCE_CATEGORY_CREATE_SUCCESS = typeof ASSISTANCE_CATEGORY_CREATE_SUCCESS

export const ASSISTANCE_CATEGORY_CREATE_FAILURE = 'ASSISTANCE_CATEGORY_CREATE_FAILURE'
export type ASSISTANCE_CATEGORY_CREATE_FAILURE = typeof ASSISTANCE_CATEGORY_CREATE_FAILURE

export const ASSISTANCE_CATEGORY_REMOVE_REQUEST = 'ASSISTANCE_CATEGORY_REMOVE_REQUEST'
export type ASSISTANCE_CATEGORY_REMOVE_REQUEST = typeof ASSISTANCE_CATEGORY_REMOVE_REQUEST

export const ASSISTANCE_CATEGORY_REMOVE_SUCCESS = 'ASSISTANCE_CATEGORY_REMOVE_SUCCESS'
export type ASSISTANCE_CATEGORY_REMOVE_SUCCESS = typeof ASSISTANCE_CATEGORY_REMOVE_SUCCESS

export const ASSISTANCE_CATEGORY_REMOVE_FAILURE = 'ASSISTANCE_CATEGORY_REMOVE_FAILURE'
export type ASSISTANCE_CATEGORY_REMOVE_FAILURE = typeof ASSISTANCE_CATEGORY_REMOVE_FAILURE

/* ---------------- SERVICES CONSTANTS ---------------- */
export enum SERVICE_LIST_TYPE {
  ACTIVE = 'active',
  ARCHIVED = 'archived'
}

export enum SERVICE_COLUMN {
  ICON = 'Icon',
  NAME = 'Service Name',
  INTERNALNAME = 'Internal Name',
  PROGRAM = 'Service Program',
  ORGANIZATION = 'Organization',
  MEMBERSHIP_REQUIRED = 'Membership Required',
  VIEW_OPTIONS = 'View Options',
  TRIP_LIMIT = 'Trip Limit'
}

export enum DAYS_OF_WEEK {
  SUNDAY = 'sun',
  MONDAY = 'mon',
  TUESDAY = 'tue',
  WEDNESDAY = 'wed',
  THURSDAY = 'thu',
  FRIDAY = 'fri',
  SATARDAY = 'sat'
}

export enum SERVICE_EDIT_URL {
  MAIN_INFO = '',
  PROVIDERS_AND_PRODUCTS = 'providers',
  PRODUCTS = 'products',
  SERVICE_DAYS_AND_HOURS = 'service-days',
  GOIN_ZONES = 'zones',
  PRICING_BREAKDOWN = 'pricing',
  MEMBER = 'member',
  PASSENGER_TYPES = 'passengerType',
  SUGGESTED_LOCATIONS = 'suggested-locations',
  GROUP_RIDE_SETTINGS = 'groupRideSettings',
  DESIGNATED_HOTSPOTS = 'designatedHotspots'
}

export enum EXPORT_TYPES {
  EXCEL = 'Excel',
  PDF = 'PDF',
  CSV = 'CSV'
}

export const SERVICE_LIST_REQUEST = 'SERVICE_LIST_REQUEST'

export const SERVICE_LIST_SUCCESS = 'SERVICE_LIST_SUCCESS'

export const SERVICE_LIST_TOTAL_SUCCESS = 'SERVICE_LIST_TOTAL_SUCCESS'

export const SERVICE_LIST_FAIL = 'SERVICE_LIST_FAIL'

export const SERVICE_ITEM_REQUEST = 'SERVICE_ITEM_REQUEST'

export const SERVICE_ITEM_SUCCESS = 'SERVICE_ITEM_SUCCESS'

export const SERVICE_ITEM_FAIL = 'SERVICE_ITEM_FAIL'

export const UPDATE_SERVICE_FILTERS = 'UPDATE_SERVICE_FILTERS'

export const SERVICE_LIST_UPDATE_COLUMNS = 'SERVICE_LIST_UPDATE_COLUMNS'

export const TRIP_MENU_SERVICE_LIST_REQUEST = 'TRIP_MENU_SERVICE_LIST_REQUEST'

export const TRIP_MENU_SERVICE_LIST_SUCCESS = 'TRIP_MENU_SERVICE_LIST_SUCCESS'

export const TRIP_MENU_SERVICE_LIST_FAIL = 'TRIP_MENU_SERVICE_LIST_FAIL'

/* ---------------- PAYMENT METHODS CONSTANTS ---------------- */
export const PAYMENT_METHODS_LIST_REQUEST = 'PAYMENT_METHODS_LIST_REQUEST'
export const PAYMENT_METHODS_LIST_SUCCESS = 'PAYMENT_METHODS_LIST_SUCCESS'
export const PAYMENT_METHODS_LIST_FAIL = 'PAYMENT_METHODS_LIST_FAIL'

export const PAYMENT_METHODS_UPDATE_REQUEST = 'PAYMENT_METHODS_UPDATE_REQUEST'
export const PAYMENT_METHODS_UPDATE_SUCCESS = 'PAYMENT_METHODS_UPDATE_SUCCESS'
export const PAYMENT_METHODS_UPDATE_FAIL = 'PAYMENT_METHODS_UPDATE_FAIL'

export const PAYMENT_METHODS_ADD_SUCCESS = 'PAYMENT_METHODS_ADD_SUCCESS'

/* ---------------- OPERATOR CONSTANTS ---------------- */

export const DRIVERS_LIST_REQUEST = 'DRIVERS_LIST_REQUEST'
export const DRIVERS_LIST_SUCCESS = 'DRIVERS_LIST_SUCCESS'
export const DRIVERS_LIST_FAIL = 'DRIVERS_LIST_FAIL'

export const DRIVER_SESSION_LIST_REQUEST = 'DRIVER_SESSION_LIST_REQUEST'
export const DRIVER_SESSION_LIST_SUCCESS = 'DRIVER_SESSION_LIST_SUCCESS'
export const DRIVER_SESSION_LIST_FAIL = 'DRIVER_SESSION_LIST_FAIL'

export const DRIVER_SESSION_LIST_V2_REQUEST = 'DRIVER_SESSION_LIST_V2_REQUEST'
export const DRIVER_SESSION_LIST_V2_SUCCESS = 'DRIVER_SESSION_LIST_V2_SUCCESS'
export const DRIVER_SESSION_LIST_V2_FAIL = 'DRIVER_SESSION_LIST_V2_FAIL'

export const DRIVER_CREATE_SESSION_REQUEST = 'DRIVER_CREATE_SESSION_REQUEST'
export const DRIVER_CREATE_SESSION_SUCCESS = 'DRIVER_CREATE_SESSION_SUCCESS'
export const DRIVER_CREATE_SESSION_FAIL = 'DRIVER_CREATE_SESSION_FAIL'

export const DRIVER_EDIT_SESSION_REQUEST = 'DRIVER_EDIT_SESSION_REQUEST'
export const DRIVER_EDIT_SESSION_SUCCESS = 'DRIVER_EDIT_SESSION_SUCCESS'
export const DRIVER_EDIT_SESSION_FAIL = 'DRIVER_EDIT_SESSION_FAIL'

export const DRIVER_DELETE_SESSION_REQUEST = 'DRIVER_DELETE_SESSION_REQUEST'
export const DRIVER_DELETE_SESSION_SUCCESS = 'DRIVER_DELETE_SESSION_SUCCESS'
export const DRIVER_DELETE_SESSION_FAIL = 'DRIVER_DELETE_SESSION_FAIL'

export const DRIVER_GET_ACCUMULATED_HOURS_REQUEST = 'DRIVER_GET_ACCUMULATED_HOURS_REQUEST'
export const DRIVER_GET_ACCUMULATED_HOURS_SUCCESS = 'DRIVER_GET_ACCUMULATED_HOURS_SUCCESS'
export const DRIVER_GET_ACCUMULATED_HOURS_FAIL = 'DRIVER_GET_ACCUMULATED_HOURS_FAIL'

export const LIVE_OPERATORS_REQUEST = 'LIVE_OPERATORS_REQUEST'
export const LIVE_OPERATORS_SUCCESS = 'LIVE_OPERATORS_SUCCESS'
export const LIVE_OPERATORS_FAIL = 'LIVE_OPERATORS_FAIL'

export const OPERATOR_REMOVE_PRODUCT_REQUEST = 'OPERATOR_REMOVE_PRODUCT_REQUEST'
export const OPERATOR_REMOVE_PRODUCT_SUCCESS = 'OPERATOR_REMOVE_PRODUCT_SUCCESS'
export const OPERATOR_REMOVE_PRODUCT_FAILURE = 'OPERATOR_REMOVE_PRODUCT_FAILURE'

export const GET_OPERATOR_SCHEDULE_REQUEST = 'GET_OPERATOR_SCHEDULE_REQUEST'
export const GET_OPERATOR_SCHEDULE_SUCCESS = 'GET_OPERATOR_SCHEDULE_SUCCESS'
export const GET_OPERATOR_SCHEDULE_FAIL = 'GET_OPERATOR_SCHEDULE_FAIL'

export const GET_OPERATOR_METRICS_REQUEST = 'GET_OPERATOR_METRICS_REQUEST'
export const GET_OPERATOR_METRICS_SUCCESS = 'GET_OPERATOR_METRICS_SUCCESS'
export const GET_OPERATOR_METRICS_FAIL = 'GET_OPERATOR_METRICS_FAIL'

export const SHOW_DRIVERS_LIST = 'SHOW_DRIVERS_LIST'

export const FETCH_DRIVER_REQUEST = 'FETCH_DRIVER_REQUEST'

export const FETCH_DRIVER_SUCCESS = 'FETCH_DRIVER_SUCCESS'

export const FETCH_DRIVER_FAIL = 'FETCH_DRIVER_FAIL'

export const ARCHIVED_DRIVERS_REQUEST = 'ARCHIVED_DRIVERS_REQUEST'

export const ARCHIVED_DRIVERS_SUCCESS = 'ARCHIVED_DRIVERS_SUCCESS'

export const ARCHIVED_DRIVERS_FAIL = 'ARCHIVED_DRIVERS_FAIL'

export const UPDATE_DRIVER_STATUS_REQUEST = 'UPDATE_DRIVER_STATUS_REQUEST'

export const UPDATE_DRIVER_STATUS_SUCCESS = 'UPDATE_DRIVER_STATUS_SUCCESS'

export const UPDATE_DRIVER_STATUS_FAIL = 'UPDATE_DRIVER_STATUS_FAIL'

export const UPDATE_DRIVER_FILTERS = 'UPDATE_DRIVER_FILTERS'

export const DRIVER_PUSH_NOTIFICATION_SUCCESS_MESSAGE = 'DRIVER_PUSH_NOTIFICATION_SUCCESS_MESSAGE'
export const DRIVER_PUSH_NOTIFICATION_FAIL = 'DRIVER_PUSH_NOTIFICATION_FAIL'

export const GET_OPERATOR_LOCATION_REQUEST = 'GET_OPERATOR_LOCATION_REQUEST'
export const GET_OPERATOR_LOCATION_SUCCESS = 'GET_OPERATOR_LOCATION_SUCCESS'
export const GET_OPERATOR_LOCATION_FAIL = 'GET_OPERATOR_LOCATION_FAIL'

export const TO_ARCHIVED_DRIVER_REQUEST = 'TO_ARCHIVED_DRIVER_REQUEST'
export type TO_ARCHIVED_DRIVER_REQUEST = typeof TO_ARCHIVED_DRIVER_REQUEST

export const TO_ARCHIVED_DRIVER_SUCCESS = 'TO_ARCHIVED_DRIVER_SUCCESS'
export type TO_ARCHIVED_DRIVER_SUCCESS = typeof TO_ARCHIVED_DRIVER_SUCCESS

export const TO_ARCHIVED_DRIVER_FAIL = 'TO_ARCHIVED_DRIVER_FAIL'
export type TO_ARCHIVED_DRIVER_FAIL = typeof TO_ARCHIVED_DRIVER_FAIL

export const RESTORE_ARCHIVED_DRIVER_REQUEST = 'RESTORE_ARCHIVED_DRIVER_REQUEST'
export type RESTORE_ARCHIVED_DRIVER_REQUEST = typeof RESTORE_ARCHIVED_DRIVER_REQUEST

export const RESTORE_ARCHIVED_DRIVER_SUCCESS = 'RESTORE_ARCHIVED_DRIVER_SUCCESS'
export type RESTORE_ARCHIVED_DRIVER_SUCCESS = typeof RESTORE_ARCHIVED_DRIVER_SUCCESS

export const DRIVER_ARCHIVE_RESTORE_SUCCESS = 'DRIVER_ARCHIVE_RESTORE_SUCCESS'
export type DRIVER_ARCHIVE_RESTORE_SUCCESS = typeof DRIVER_ARCHIVE_RESTORE_SUCCESS

export const RESTORE_ARCHIVED_DRIVER_FAIL = 'RESTORE_ARCHIVED_DRIVER_FAIL'
export type RESTORE_ARCHIVED_DRIVER_FAIL = typeof RESTORE_ARCHIVED_DRIVER_FAIL

export const TRIP_HISTORY_DRIVER_REQUEST = 'TRIP_HISTORY_DRIVER_REQUEST'

export const TRIP_HISTORY_DRIVER_SUCCESS = 'TRIP_HISTORY_DRIVER_SUCCESS'

export const TRIP_HISTORY_DRIVER_FAIL = 'TRIP_HISTORY_DRIVER_FAIL'

//Weather
export const TRIP_WEATHER_UPDATES_REQUEST = 'REQUEST_TRIP_WEATHER_UPDATES'
export const TRIP_WEATHER_UPDATES_SUCCESS = 'TRIP_WEATHER_UPDATES_SUCCESS'
export const TRIP_WEATHER_UPDATES_FAIL = 'TRIP_WEATHER_UPDATES_FAIL'

export const SELECT_HISTORY_TRIP_DRIVER = 'SELECT_HISTORY_TRIP_DRIVER'

export const ADD_DRIVER_PROVIDER = 'ADD_DRIVER_PROVIDER'

export const NEXT_STEP = 'NEXT_STEP'

export const PREV_STEP = 'PREV_STEP'

export const ADD_DRIVER_INFO_FAIL = 'ADD_DRIVER_INFO_FAIL'

export const ADD_DRIVER_INFO_REQUEST = 'ADD_DRIVER_INFO_REQUEST'

export const ADD_DRIVER_INFO_SUCCESS = 'ADD_DRIVER_INFO_SUCCESS'

export const ADD_PRODUCTS_TO_DRIVER_REQUEST = 'ADD_PRODUCTS_TO_DRIVER_REQUEST'

export const ADD_PRODUCTS_TO_DRIVER_SUCCESS_MESSAGE = 'ADD_PRODUCTS_TO_DRIVER_SUCCESS_MESSAGE'

export const ADD_PRODUCTS_TO_DRIVER_FAIL = 'ADD_PRODUCTS_TO_DRIVER_FAIL'

export enum DRIVERS_STATUSES_TYPE {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVED = 'archived'
}

export const SERVICE_SET_NAME = 'SERVICE_SET_NAME'

export const SERVICE_CATEGORIES_REQUEST = 'SERVICE_CATEGORIES_REQUEST'

export const SERVICE_CATEGORIES_SUCCESS = 'SERVICE_CATEGORIES_SUCCESS'

export const SERVICE_CATEGORIES_FAIL = 'SERVICE_CATEGORIES_FAIL'

export const SERVICE_PROVIDERS_REQUEST = 'SERVICE_PROVIDERS_REQUEST'

export const SERVICE_PROVIDERS_SUCCESS = 'SERVICE_PROVIDERS_SUCCESS'

export const SERVICE_BOUND_PROVIDERS_SUCCESS = 'SERVICE_BOUND_PROVIDERS_SUCCESS'

export const SERVICE_PROVIDERS_FAIL = 'SERVICE_PROVIDERS_FAIL'

export const SERVICE_SELECT_PROVIDER = 'SERVICE_SELECT_PROVIDER'

export const SERVICE_REMOVE_PROVIDER = 'SERVICE_REMOVE_PROVIDER'

export const SERVICE_SELECT_PRODUCT = 'SERVICE_SELECT_PRODUCT'

export const SERVICE_REMOVE_PRODUCT = 'SERVICE_REMOVE_PRODUCT'

export const SERVICE_SEARCH_REQUEST = 'SERVICE_SEARCH_REQUEST'

export const SERVICE_SEARCH_SUCCESS = 'SERVICE_SEARCH_SUCCESS'

export const SERVICE_SEARCH_FAIL = 'SERVICE_SEARCH_FAIL'

export const WORKING_HOURS_REQUEST = 'WORKING_HOURS_REQUEST'

export const WORKING_HOURS_SUCCESS = 'WORKING_HOURS_SUCCESS'

export const WORKING_HOURS_FAIL = 'WORKING_HOURS_FAIL'

export const WORKING_HOURS_ADD_ITEM = 'WORKING_HOURS_ADD_ITEM'

export const WORKING_HOURS_REMOVE_ITEM_SUCCESS = 'WORKING_HOURS_REMOVE_ITEM_SUCCESS'

export const WORKING_HOURS_REMOVE_ITEM_FAIL = 'WORKING_HOURS_REMOVE_ITEM_FAIL'

export const HOLIDAY_REMOVE_ITEM_SUCCESS = 'HOLIDAY_REMOVE_ITEM_SUCCESS'

export const HOLIDAY_REMOVE_ITEM_FAIL = 'HOLIDAY_REMOVE_ITEM_FAIL'

export const WORKING_HOURS_SET_FROM = 'WORKING_HOURS_SET_FROM'

export const WORKING_HOURS_SET_UNTIL = 'WORKING_HOURS_SET_UNTIL'

export const WORKING_HOURS_SET_DAYS = 'WORKING_HOURS_SET_DAYS'

export const WORKING_HOURS_SET_ALL_DAYS_ACTIVE = 'WORKING_HOURS_SET_ALL_DAYS_ACTIVE'

export const HOLIDAYS_REQUEST = 'HOLIDAYS_REQUEST'

export const HOLIDAYS_SUCCESS = 'HOLIDAYS_SUCCESS'

export const HOLIDAYS_FAIL = 'HOLIDAYS_FAIL'

export const HOLIDAYS_ADD_ITEM = 'HOLIDAYS_ADD_ITEM'

export const HOLIDAYS_REMOVE_ITEM = 'HOLIDAYS_REMOVE_ITEM'

export const HOLIDAYS_SET_FROM = 'HOLIDAYS_SET_FROM'

export const HOLIDAYS_SET_UNTIL = 'HOLIDAYS_SET_UNTIL'

export const HOLIDAYS_SET_DATE = 'HOLIDAYS_SET_DATE'

export const SERVICE_EDIT_SET_COMPLETED = 'SERVICE_EDIT_SET_COMPLETED'

export const SERVICE_EDIT_SET_CURRENT_STEP = 'SERVICE_EDIT_SET_CURRENT_STEP'

export const SERVICE_EDIT_SET_FETCHING = 'SERVICE_EDIT_SET_FETCHING'

export const SERVICE_EDIT_SET_FETCHING_ERROR = 'SERVICE_EDIT_SET_FETCHING_ERROR'

export const SERVICE_EDIT_SET_UPDATING = 'SERVICE_EDIT_SET_UPDATING'

export const SERVICE_EDIT_SET_UPDATING_ERROR = 'SERVICE_EDIT_SET_UPDATING_ERROR'

export const SERVICE_EDIT_SET_CHANGED = 'SERVICE_EDIT_SET_CHANGED'

export const SERVICE_EDIT_SET_SERVICE_ID = 'SERVICE_EDIT_SET_SERVICE_ID'

export const SERVICE_MAIN_INFO_REQUEST_SUCCESS = 'SERVICE_MAIN_INFO_REQUEST_SUCCESS'

//PricingType
export const SERVICE_PRICING_TYPE_REQUEST_SUCCESS = 'SERVICE_PRICING_TYPE_REQUEST_SUCCESS'
export const SERVICE_PRICING_TYPE_REQUEST_FAIL = 'SERVICE_PRICING_TYPE_REQUEST_FAIL'

export const SERVICE_PRICING_TYPE_EDIT_SUCCESS = 'SERVICE_PRICING_TYPE_EDIT_SUCCESS'
export const SERVICE_PRICING_TYPE_EDIT_FAIL = 'SERVICE_PRICING_TYPE_EDIT_FAIL'

// DESIGNATED ZONE

export const SERVICE_DESIGNATED_ZONE_DELETE_REQUEST = 'SERVICE_DESIGNATED_ZONE_DELETE_REQUEST'
export const SERVICE_DESIGNATED_ZONE_DELETE_SUCCESS_MESSAGE = 'SERVICE_DESIGNATED_ZONE_DELETE_SUCCESS_MESSAGE'
export const SERVICE_DESIGNATED_ZONE_DELETE_FAIL = 'SERVICE_DESIGNATED_ZONE_DELETE_FAIL'

export const SERVICE_HOTSPOTS_LIST_REQUEST = 'SERVICE_HOTSPOTS_LIST_REQUEST'
export const SERVICE_HOTSPOTS_LIST_SUCCESS = 'SERVICE_HOTSPOTS_LIST_SUCCESS'
export const SERVICE_HOTSPOTS_LIST_FAIL = 'SERVICE_HOTSPOTS_LIST_FAIL'

export const SERVICE_HOTSPOTS_UPDATE_REQUEST = 'SERVICE_HOTSPOTS_UPDATE_REQUEST'
export const SERVICE_HOTSPOTS_UPDATE_SUCCESS_MESSAGE = 'SERVICE_HOTSPOTS_UPDATE_SUCCESS_MESSAGE'
export const SERVICE_HOTSPOTS_UPDATE_FAIL = 'SERVICE_HOTSPOTS_UPDATE_FAIL'

export const SERVICE_DESIGNATED_HOTSPOT_DELETE_REQUEST = 'SERVICE_DESIGNATED_HOTSPOT_DELETE_REQUEST'
export const SERVICE_DESIGNATED_HOTSPOT_DELETE_SUCCESS_MESSAGE = 'SERVICE_DESIGNATED_HOTSPOT_DELETE_SUCCESS_MESSAGE'
export const SERVICE_DESIGNATED_HOTSPOT_DELETE_FAIL = 'SERVICE_DESIGNATED_HOTSPOT_DELETE_FAIL'

export const SERVICE_CREATE_REQUEST = 'SERVICE_CREATE_REQUEST'

export const SERVICE_CREATE_SUCCESS = 'SERVICE_CREATE_SUCCESS'

export const SERVICE_CREATE_FAIL = 'SERVICE_CREATE_FAIL'

export const SERVICE_EDIT_CLEAR_STATE = 'SERVICE_EDIT_CLEAR_STATE'

/* ---------------- VEHICLES CONSTANTS ---------------- */

export const UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_REQUEST =
  'UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_REQUEST'

export const UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_SUCCESS =
  'UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_SUCCESS'

export const UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_FAIL = 'UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_FAIL'

export const GET_VEHICLES_REQUEST = 'GET_ALL_VEHICLES_REQUEST'

export const GET_VEHICLES_SUCCESS = 'GET_ALL_VEHICLES_SUCCESS'

export const GET_VEHICLES_FAIL = 'GET_ALL_VEHICLES_FAIL'

export const DEACTIVATE_VEHICLE_REQUEST = 'DEACTIVATE_VEHICLE_REQUEST'

export const DEACTIVATE_VEHICLE_SUCCESS = 'DEACTIVATE_VEHICLE_SUCCESS'

export const DEACTIVATE_VEHICLE_FAIL = 'DEACTIVATE_VEHICLE_FAIL'

export const ACTIVATE_VEHICLE_REQUEST = 'ACTIVATE_VEHICLE_REQUEST'

export const ACTIVATE_VEHICLE_SUCCESS = 'ACTIVATE_VEHICLE_SUCCESS'

export const ACTIVATE_VEHICLE_FAIL = 'ACTIVATE_VEHICLE_FAIL'

export const SELECT_VEHICLE = 'SELECT_VEHICLE'

export const REMOVE_VEHICLE_REQUEST = 'REMOVE_VEHICLE_REQUEST'

export const REMOVE_VEHICLE_SUCCESS = 'REMOVE_VEHICLE_SUCCESS'

export const REMOVE_VEHICLE_FAIL = 'REMOVE_VEHICLE_FAIL'

export const GET_PARAMS_FILTER_REQUEST = 'GET_PARAMS_FILTER_REQUEST'

export const GET_PARAMS_FILTER_SUCCESS = 'GET_PARAMS_FILTER_SUCCESS'

export const GET_PARAMS_FILTER_FAIL = 'GET_PARAMS_FILTER_FAIL'

export const TOGGLE_FILTER = 'TOGGLE_FILTER'

export const SELECT_PROVIDER = 'SELECT_PROVIDER'

export const SELECT_PRODUCT = 'SELECT_PRODUCT'

export const APPLY_FILTER_REQUEST = 'APPLY_FILTER_REQUEST'

export const APPLY_FILTER_SUCCESS = 'APPLY_FILTER_SUCCESS'

export const APPLY_FILTER_FAIL = 'APPLY_FILTER_FAIL'

export const GET_VEHICLE_CREATE_ACCOMODATIONS_REQUEST = 'GET_VEHICLE_CREATE_ACCOMODATIONS_REQUEST'

export const GET_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS = 'GET_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS'

export const GET_VEHICLE_CREATE_ACCOMODATIONS_FAIL = 'GET_VEHICLE_CREATE_ACCOMODATIONS_FAIL'

export const CREATE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST = 'CREATE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST'

export const CREATE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS = 'CREATE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS'

export const CREATE_VEHICLE_CREATE_ACCOMODATIONS_FAIL = 'CREATE_VEHICLE_CREATE_ACCOMODATIONS_FAIL'

export const REMOVE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST = 'REMOVE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST'

export const REMOVE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS = 'REMOVE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS'

export const REMOVE_VEHICLE_CREATE_ACCOMODATIONS_FAIL = 'REMOVE_VEHICLE_CREATE_ACCOMODATIONS_FAIL'

export const UNASSIGN_DRIVER_REQUEST = 'UNASSIGN_DRIVER_REQUEST'

export const UNASSIGN_DRIVER_SUCCESS = 'UNASSIGN_DRIVER_SUCCESS'

export const UNASSIGN_DRIVER_FAIL = 'UNASSIGN_DRIVER_FAIL'

export const ASSIGN_DRIVER_FAIL = 'ASSIGN_DRIVER_FAIL'

export const UPDATE_VEHICLE_FILTERS = 'UPDATE_VEHICLE_FILTERS'

export const GET_VEHICLE_CREATE_OPTIONS_REQUEST = 'GET_VEHICLE_CREATE_OPTIONS_REQUEST'

export const GET_VEHICLE_CREATE_OPTIONS_SUCCESS = 'GET_VEHICLE_CREATE_OPTIONS_SUCCESS'

export const GET_VEHICLE_CREATE_OPTIONS_FAIL = 'GET_VEHICLE_CREATE_OPTIONS_FAIL'

export const CREATE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST = 'CREATE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST'

export const CREATE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS = 'CREATE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS'

export const CREATE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL = 'CREATE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL'

export const REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST = 'REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST'

export const REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS = 'REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS'

export const REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL = 'REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL'

export const CREATE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST = 'CREATE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST'

export const CREATE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS = 'CREATE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS'

export const CREATE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL = 'CREATE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL'

export const REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST = 'REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST'

export const REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS = 'REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS'

export const REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL = 'REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL'

export const CREATE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST = 'CREATE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST'

export const CREATE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS = 'CREATE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS'

export const CREATE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL = 'CREATE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL'

export const REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST = 'REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST'

export const REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS = 'REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS'

export const REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL = 'REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL'

export const CREATE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST = 'CREATE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST'

export const CREATE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS = 'CREATE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS'

export const CREATE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL = 'CREATE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL'

export const REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST = 'REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST'

export const REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS = 'REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS'

export const REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL = 'REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL'

export const GET_SINGLE_VEHICLES_REQUEST = 'GET_SINGLE_VEHICLES_REQUEST'

export const GET_SINGLE_VEHICLES_SUCCESS = 'GET_SINGLE_VEHICLES_SUCCESS'

export const GET_SINGLE_VEHICLES_FAIL = 'GET_SINGLE_VEHICLES_FAIL'

export const SET_VEHICLE_STATE_TO_INITIAL = 'SET_VEHICLE_STATE_TO_INITIAL'

export const CREATE_ONE_VEHICLE_REQUEST = 'CREATE_ONE_VEHICLE_REQUEST'

export const CREATE_ONE_VEHICLE_SUCCESS = 'CREATE_ONE_VEHICLE_SUCCESS'

export const CREATE_ONE_VEHICLE_FAIL = 'CREATE_ONE_VEHICLE_FAIL'

export const UPDATE_ONE_VEHICLE_REQUEST = 'UPDATE_ONE_VEHICLE_REQUEST'

export const UPDATE_ONE_VEHICLE_SUCCESS = 'UPDATE_ONE_VEHICLE_SUCCESS'

export const UPDATE_ONE_VEHICLE_FAIL = 'UPDATE_ONE_VEHICLE_FAIL'

export const SAVE_VEHICLE_PROVIDERS_AND_PRODUCTS_SUCCESS = 'SAVE_VEHICLE_PROVIDERS_AND_PRODUCTS_SUCCESS'

export const SAVE_VEHICLE_ACCESS_AND_CAPACITY_SUCCESS = 'SAVE_VEHICLE_ACCESS_AND_CAPACITY_SUCCESS'

export const SAVE_VEHICLE_ACCOMMODATIONS_SUCCESS = 'SAVE_VEHICLE_ACCOMMODATIONS_SUCCESS'

export const SET_CURRENT_STEP_CREATE_VEHICLE = 'SET_CURRENT_STEP_CREATE_VEHICLE'

export const GET_ACCOMMODATION_REQUEST = 'GET_ACCOMMODATIONS_REQUEST'

export const GET_ACCOMMODATION_SUCCESS = 'GET_ACCOMMODATIONS_SUCCESS'

export const GET_ACCOMMODATION_FAIL = 'GET_ACCOMMODATIONS_FAIL'

export const UPDATE_VEHICLE_ACCOMMODATIONS_REQUEST = 'UPDATE_VEHICLE_ACCOMMODATIONS_REQUEST'

export const UPDATE_VEHICLE_ACCOMMODATIONS_SUCCESS = 'UPDATE_VEHICLE_ACCOMMODATIONS_SUCCESS'

export const UPDATE_VEHICLE_ACCOMMODATIONS_FAIL = 'UPDATE_VEHICLE_ACCOMMODATIONS_FAIL'

export const SERVICE_ARCHIVE_MODAL_SHOW = 'SERVICE_ARCHIVE_MODAL_SHOW'

export const SERVICE_ARCHIVE_MODAL_HIDE = 'SERVICE_ARCHIVE_MODAL_HIDE'

export const SERVICE_ARCHIVE_REQUEST = 'SERVICE_ARCHIVE_REQUEST'

export const SERVICE_ARCHIVE_SUCCESS = 'SERVICE_ARCHIVE_SUCCESS'

export const SERVICE_ARCHIVE_FAIL = 'SERVICE_ARCHIVE_FAIL'

export const SERVICE_RESTORE_MODAL_SHOW = 'SERVICE_RESTORE_MODAL_SHOW'

export const SERVICE_RESTORE_MODAL_HIDE = 'SERVICE_RESTORE_MODAL_HIDE'

export const SERVICE_RESTORE_REQUEST = 'SERVICE_RESTORE_REQUEST'

export const SERVICE_RESTORE_SUCCESS = 'SERVICE_RESTORE_SUCCESS'

export const SERVICE_RESTORE_FAIL = 'SERVICE_RESTORE_FAIL'

export const SERVICE_PRICING_REQUEST = 'SERVICE_PRICING_REQUEST'

export const SERVICE_PRICING_REQUEST_SUCCESS = 'SERVICE_PRICING_REQUEST_SUCCESS'

export const SERVICE_PRICING_REQUEST_FAIL = 'SERVICE_PRICING_REQUEST_FAIL'

export const SERVICE_PRICING_UPDATE = 'SERVICE_PRICING_UPDATE'

export const SERVICE_PRICING_UPDATE_SUCCESS = 'SERVICE_PRICING_UPDATE_SUCCESS'

export const SERVICE_PRICING_UPDATE_FAIL = 'SERVICE_PRICING_UPDATE_FAIL'

export const SERVICE_PRICING_DISCOUNT_REQUEST = 'SERVICE_PRICING_DISCOUNT_REQUEST'

export const SERVICE_PRICING_DISCOUNT_SUCCESS = 'SERVICE_PRICING_DISCOUNT_SUCCESS'

export const SERVICE_PRICING_DISCOUNT_FAIL = 'SERVICE_PRICING_DISCOUNT_FAIL'

export const SERVICE_PROGRAM_REQUEST = 'SERVICE_PROGRAM_REQUEST'

export const SERVICE_PROGRAM_SUCCESS = 'SERVICE_PROGRAM_SUCCESS'

export const SERVICE_PROGRAM_FAIL = 'SERVICE_PROGRAM_FAIL'

export const SERVICE_PROGRAM_DELETE_REQUEST = 'SERVICE_PROGRAM_DELETE_REQUEST'

export const SERVICE_PROGRAM_DELETE_SUCCESS = 'SERVICE_PROGRAM_DELETE_SUCCESS'

export const SERVICE_PROGRAM_DELETE_FAIL = 'SERVICE_PROGRAM_DELETE_FAIL'

export const SERVICE_PROGRAM_UPDATE_REQUEST = 'SERVICE_PROGRAM_UPDATE_REQUEST'

export const SERVICE_PROGRAM_UPDATE_SUCCESS = 'SERVICE_PROGRAM_UPDATE_SUCCESS'

export const SERVICE_PROGRAM_UPDATE_FAIL = 'SERVICE_PROGRAM_UPDATE_FAIL'

export const UPDATE_VEHICLE_CAPACITY_REQUEST = 'UPDATE_VEHICLE_CAPACITY_REQUEST'

export const UPDATE_VEHICLE_CAPACITY_SUCCESS = 'UPDATE_VEHICLE_CAPACITY_SUCCESS'

export const UPDATE_VEHICLE_CAPACITY_FAIL = 'UPDATE_VEHICLE_CAPACITY_FAIL'

export const SERVICE_LOCATION_LIST_REQUEST = 'SERVICE_LOCATION_LIST_REQUEST'

export const SERVICE_LOCATION_LIST_SUCCESS = 'SERVICE_LOCATION_LIST_SUCCESS'

export const SERVICE_LOCATION_LIST_FAIL = 'SERVICE_LOCATION_LIST_TOTAL_FAIL'

export const SERVICE_CREATE_LOCATION_REQUEST = 'SERVICE_CREATE_LOCATION_REQUEST'

export const SERVICE_CREATE_LOCATION_SUCCESS = 'SERVICE_CREATE_LOCATION_SUCCESS'

export const SERVICE_CREATE_LOCATION_FAIL = 'SERVICE_CREATE_LOCATION_FAIL'

export const SERVICE_UPDATE_LOCATION_REQUEST = 'SERVICE_UPDATE_LOCATION_REQUEST'

export const SERVICE_UPDATE_LOCATION_SUCCESS = 'SERVICE_UPDATE_LOCATION_SUCCESS'

export const SERVICE_UPDATE_LOCATION_FAIL = 'SERVICE_UPDATE_LOCATION_FAIL'

export const SERVICE_DELETE_LOCATION_REQUEST = 'SERVICE_DELETE_LOCATION_REQUEST'

export const SERVICE_DELETE_LOCATION_SUCCESS = 'SERVICE_DELETE_LOCATION_SUCCESS'

export const SERVICE_DELETE_LOCATION_FAIL = 'SERVICE_DELETE_LOCATION_FAIL'
/* ---------------- ORGANIZATIONS CONSTANTS ---------------- */

export const ORGANIZATION_LIST_REQUEST = 'ORGANIZATION_LIST_REQUEST'
export type ORGANIZATION_LIST_REQUEST = typeof ORGANIZATION_LIST_REQUEST

export const ORGANIZATION_LIST_SUCCESS = 'ORGANIZATION_LIST_SUCCESS'
export type ORGANIZATION_LIST_SUCCESS = typeof ORGANIZATION_LIST_SUCCESS

export const ORGANIZATION_LIST_FAILURE = 'ORGANIZATION_LIST_FAILURE'
export type ORGANIZATION_LIST_FAILURE = typeof ORGANIZATION_LIST_FAILURE

export const GET_ORGANIZATION_LEGAL_ENTITY_REQUEST = 'GET_ORGANIZATION_LEGAL_ENTITY_REQUEST'
export type GET_ORGANIZATION_LEGAL_ENTITY_REQUEST = typeof GET_ORGANIZATION_LEGAL_ENTITY_REQUEST

export const GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS = 'GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS'
export type GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS = typeof GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS

export const GET_ORGANIZATION_LEGAL_ENTITY_FAILURE = 'GET_ORGANIZATION_LEGAL_ENTITY_FAILURE'
export type GET_ORGANIZATION_LEGAL_ENTITY_FAILURE = typeof GET_ORGANIZATION_LEGAL_ENTITY_FAILURE

export const FETCH_ALL_ORGANIZATIONS = 'FETCH_ALL_ORGANIZATIONS'

export const FETCH_ALL_ORGANIZATIONS_SUCCESS = 'FETCH_ALL_ORGANIZATIONS_SUCCESS'

export const FETCH_ALL_ORGANIZATIONS_FAIL = 'FETCH_ALL_ORGANIZATIONS_FAIL'

export const FETCH_ALL_ROLES = 'FETCH_ALL_ROLES'

export const FETCH_ALL_ROLES_SUCCESS = 'FETCH_ALL_ROLES_SUCCESS'

export const FETCH_ALL_ROLES_FAIL = 'FETCH_ALL_ROLES_FAIL'

export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION'
export type CREATE_ORGANIZATION = typeof CREATE_ORGANIZATION

export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS'
export type CREATE_ORGANIZATION_SUCCESS = typeof CREATE_ORGANIZATION_SUCCESS

export const CREATE_ORGANIZATION_FAIL = 'CREATE_ORGANIZATION_FAIL'
export type CREATE_ORGANIZATION_FAIL = typeof CREATE_ORGANIZATION_FAIL

export const CREATE_ORGANIZATION_CLEAR = 'CREATE_ORGANIZATION_CLEAR'
export type CREATE_ORGANIZATION_CLEAR = typeof CREATE_ORGANIZATION_CLEAR

export const CLEAR_ORGANIZATION_LEGAL_ENTITY = 'CLEAR_ORGANIZATION_LEGAL_ENTITY'
export type CLEAR_ORGANIZATION_LEGAL_ENTITY = typeof CLEAR_ORGANIZATION_LEGAL_ENTITY

export const CREATE_ORGANIZATION_LEGAL_ENTITY_REQUEST = 'CREATE_ORGANIZATION_LEGAL_ENTITY_REQUEST'
export type CREATE_ORGANIZATION_LEGAL_ENTITY_REQUEST = typeof CREATE_ORGANIZATION_LEGAL_ENTITY_REQUEST

export const CREATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS = 'CREATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS'
export type CREATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS = typeof CREATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS

export const CREATE_ORGANIZATION_LEGAL_ENTITY_FAILURE = 'CREATE_ORGANIZATION_LEGAL_ENTITY_FAILURE'
export type CREATE_ORGANIZATION_LEGAL_ENTITY_FAILURE = typeof CREATE_ORGANIZATION_LEGAL_ENTITY_FAILURE

export const CREATE_ORGANIZATION_BANK_ACCOUNT_REQUEST = 'CREATE_ORGANIZATION_BANK_ACCOUNT_REQUEST'
export type CREATE_ORGANIZATION_BANK_ACCOUNT_REQUEST = typeof CREATE_ORGANIZATION_BANK_ACCOUNT_REQUEST

export const CREATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS = 'CREATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS'
export type CREATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS = typeof CREATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS

export const CREATE_ORGANIZATION_BANK_ACCOUNT_FAILURE = 'CREATE_ORGANIZATION_BANK_ACCOUNT_FAILURE'
export type CREATE_ORGANIZATION_BANK_ACCOUNT_FAILURE = typeof CREATE_ORGANIZATION_BANK_ACCOUNT_FAILURE

export const REMOVE_ORGANIZATION_BANK_ACCOUNT_REQUEST = 'REMOVE_ORGANIZATION_BANK_ACCOUNT_REQUEST'
export type REMOVE_ORGANIZATION_BANK_ACCOUNT_REQUEST = typeof REMOVE_ORGANIZATION_BANK_ACCOUNT_REQUEST

export const REMOVE_ORGANIZATION_BANK_ACCOUNT_SUCCESS = 'REMOVE_ORGANIZATION_BANK_ACCOUNT_SUCCESS'
export type REMOVE_ORGANIZATION_BANK_ACCOUNT_SUCCESS = typeof REMOVE_ORGANIZATION_BANK_ACCOUNT_SUCCESS

export const REMOVE_ORGANIZATION_BANK_ACCOUNT_FAILURE = 'REMOVE_ORGANIZATION_BANK_ACCOUNT_FAILURE'
export type REMOVE_ORGANIZATION_BANK_ACCOUNT_FAILURE = typeof REMOVE_ORGANIZATION_BANK_ACCOUNT_FAILURE

export const RESET_ORGANIZATION_METADATA = 'RESET_ORGANIZATION_METADATA'
export type RESET_ORGANIZATION_METADATA = typeof RESET_ORGANIZATION_METADATA

export const UPDATE_ORGANIZATION_BANK_ACCOUNT_REQUEST = 'UPDATE_ORGANIZATION_BANK_ACCOUNT_REQUEST'
export type UPDATE_ORGANIZATION_BANK_ACCOUNT_REQUEST = typeof UPDATE_ORGANIZATION_BANK_ACCOUNT_REQUEST

export const UPDATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS = 'UPDATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS'
export type UPDATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS = typeof UPDATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS

export const UPDATE_ORGANIZATION_BANK_ACCOUNT_FAILURE = 'UPDATE_ORGANIZATION_BANK_ACCOUNT_FAILURE'
export type UPDATE_ORGANIZATION_BANK_ACCOUNT_FAILURE = typeof UPDATE_ORGANIZATION_BANK_ACCOUNT_FAILURE

export const UPDATE_ORGANIZATION_LEGAL_ENTITY_REQUEST = 'UPDATE_ORGANIZATION_LEGAL_ENTITY_REQUEST'
export type UPDATE_ORGANIZATION_LEGAL_ENTITY_REQUEST = typeof UPDATE_ORGANIZATION_LEGAL_ENTITY_REQUEST

export const UPDATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS = 'UPDATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS'
export type UPDATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS = typeof UPDATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS

export const UPDATE_ORGANIZATION_LEGAL_ENTITY_FAILURE = 'UPDATE_ORGANIZATION_LEGAL_ENTITY_FAILURE'
export type UPDATE_ORGANIZATION_LEGAL_ENTITY_FAILURE = typeof UPDATE_ORGANIZATION_LEGAL_ENTITY_FAILURE

export const FETCH_SINGLE_ORGANIZATION = 'FETCH_SINGLE_ORGANIZATION'

export const FETCH_SINGLE_ORGANIZATION_SUCCESS = 'FETCH_SINGLE_ORGANIZATION_SUCCESS'

export const FETCH_SINGLE_ORGANIZATION_FAIL = 'FETCH_SINGLE_ORGANIZATION_FAIL'

export const SEND_LOCATIONS_DATA_REQUEST = 'SEND_LOCATIONS_DATA_REQUEST'

export const SEND_LOCATIONS_DATA_SUCCESS = 'SEND_LOCATIONS_DATA_SUCCESS'

export const SEND_LOCATIONS_DATA_FAIL = 'SEND_LOCATIONS_DATA_FAIL'

export const LIST_SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST'

export const LIST_SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS'

export const LIST_SUBSCRIPTION_FAIL = 'SUBSCRIPTION_FAIL'

export const ORGANIZATION_CREATE_SUBSCRIPTION = 'ORGANIZATION_CREATE_SUBSCRIPTION'

export const ORGANIZATION_CREATE_SUBSCRIPTION_SUCCESS = 'ORGANIZATION_CREATE_SUBSCRIPTION_SUCCESS'

export const ORGANIZATION_CREATE_SUBSCRIPTION_FAIL = 'ORGANIZATION_CREATE_SUBSCRIPTION_FAIL'

export const ORGANIZATION_UPDATE_SUBSCRIPTION = 'ORGANIZATION_UPDATE_SUBSCRIPTION'

export const ORGANIZATION_UPDATE_SUBSCRIPTION_SUCCESS = 'ORGANIZATION_UPDATE_SUBSCRIPTION_SUCCESS'

export const ORGANIZATION_UPDATE_SUBSCRIPTION_FAIL = 'ORGANIZATION_UPDATE_SUBSCRIPTION_FAIL'

export const ORGANIZATION_GET_SUBSCRIPTION = 'ORGANIZATION_GET_SUBSCRIPTION'

export const ORGANIZATION_GET_SUBSCRIPTION_SUCCESS = 'ORGANIZATION_GET_SUBSCRIPTION_SUCCESS'

export const ORGANIZATION_GET_SUBSCRIPTION_FAILURE = 'ORGANIZATION_GET_SUBSCRIPTION_FAILURE'

export enum tripsStatuses {
  waitingForAccept = 'WAITING_FOR_ACCEPT',
  accepted = 'ACCEPTED',
  waitingForPickUp = 'WAITING_FOR_PICK_UP',
  enRoute = 'EN_ROUTE',
  completed = 'COMPLETED',
  pickedUp = 'PICKED_UP'
}

export const completedTripStatuses = [
  'COMPLETED',
  'CANCELLED',
  'REJECTED',
  'NO_RESPONSE_OPERATOR',
  'MANUALLY_COMPLETED'
]

export const CREATE_GOINZONE_REQUEST = 'CREATE_GOINZONE_REQUEST'

export const CREATE_GOINZONE_SUCCESS = 'CREATE_GOINZONE_SUCCESS'

export const CREATE_GOINZONE_FAIL = 'CREATE_GOINZONE_FAIL'

export const GET_GOINZONE_REQUEST = 'GET_GOINZONE_REQUEST'

export const SET_GOINZONE_VISIBLITY = 'SET_GOINZONE_VISIBLITY'

export const GET_GOINZONE_SUCCESS = 'GET_GOINZONE_SUCCESS'

export const GET_GOINZONE_FAIL = 'GET_GOINZONE_FAIL'

export const GET_GOINZONE_BY_LOCATION_REQUEST = 'GET_GOINZONE_BY_LOCATION_REQUEST'

export const GET_GOINZONE_BY_LOCATION_SUCCESS = 'GET_GOINZONE_BY_LOCATION_SUCCESS'

export const GET_GOINZONE_BY_LOCATION_FAIL = 'GET_GOINZONE_BY_LOCATION_FAIL'

export const REMOVE_GOINZONE_REQUEST = 'REMOVE_GOINZONE_REQUEST'

export const REMOVE_GOINZONE_SUCCESS = 'REMOVE_GOINZONE_SUCCESS'

export const REMOVE_GOINZONE_FAIL = 'REMOVE_GOINZONE_FAIL'

export const UPDATE_GOINZONE_REQUEST = 'UPDATE_GOINZONE_REQUEST'

export const UPDATE_GOINZONE_SUCCESS = 'UPDATE_GOINZONE_SUCCESS'

export const UPDATE_GOINZONE_FAIL = 'UPDATE_GOINZONE_FAIL'

export const CURRENT_ORG_ID_REQUEST = 'CURRENT_ORG_ID_REQUEST'

export const SET_CURRENT_ORG_SUCCESS = 'SET_CURRENT_ORG_SUCCESS'

export const CURRENT_ORG_ID_FAIL = 'CURRENT_ORG_ID_FAIL'

export const ORG_UPDATE_REQUEST = 'ORG_UPDATE_REQUEST'

export const ORG_UPDATE_SUCCESS = 'ORG_UPDATE_SUCCESS'

export const ORG_UPDATE_FAIL = 'ORG_UPDATE_FAIL'

export const ORG_SEARCH_REQUEST = 'ORG_SEARCH_REQUEST'

export const ORG_SEARCH_SUCCESS = 'ORG_SEARCH_SUCCESS'

export const ORG_SEARCH_FAIL = 'ORG_SEARCH_FAIL'

export const USERS_SUCCESS = 'USER_SUCCESS'

export const CURRENT_USER_SUCCESS = 'CURRENT_USER_SUCCESS'

export const ORG_LIST_BY_DRIVER_REQUEST = 'ORG_LIST_BY_DRIVER_REQUEST'

export const ORG_LIST_BY_DRIVER_SUCCESS = 'ORG_LIST_BY_DRIVER_SUCCESS'

export const ORG_LIST_BY_DRIVER_FAIL = 'ORG_LIST_BY_DRIVER_FAIL'

export const SWITCH_ORGANIZATION = 'SWITCH_ORGANIZATION'

export const FETCH_ORGANIZATION_PROMOTIONS = 'FETCH_ORGANIZATION_PROMOTIONS'

export const FETCH_ORGANIZATION_PROMOTIONS_FAIL = 'FETCH_ORGANIZATION_PROMOTIONS_FAIL'

export const FETCH_ORGANIZATION_PROMOTIONS_SUCCESS = 'FETCH_ORGANIZATION_PROMOTIONS_SUCCESS'

export const GET_RIDERS_PER_PROMOTION_REQUEST = 'GET_RIDERS_PER_PROMOTION_REQUEST'

export const GET_RIDERS_PER_PROMOTION_SUCCESS = 'GET_RIDERS_PER_PROMOTION_SUCCESS'

export const GET_RIDERS_PER_PROMOTION_FAILURE = 'GET_RIDERS_PER_PROMOTION_FAILURE'

export const GET_RIDERS_PER_PROMOTION_COUNT = 'GET_RIDERS_PER_PROMOTION_COUNT'

export const FETCH_ORGANIZATION_PROMOTIONS_COUNT_SUCCESS = 'FETCH_ORGANIZATION_PROMOTIONS_COUNT_SUCCESS'

export const UPDATE_PROMOTIONS_FILTERS = 'UPDATE_PROMOTIONS_FILTERS'

export const CREATE_PROMOTION = 'CREATE_PROMOTION'

export const CREATE_PROMOTION_FAIL = 'CREATE_PROMOTION_FAIL'

export const CREATE_PROMOTION_SUCCESS = 'CREATE_PROMOTION_SUCCESS'

export const DELETE_PROMOTION = 'DELETE_PROMOTION'

export const DELETE_PROMOTION_FAIL = 'DELETE_PROMOTION_FAIL'

export const DELETE_PROMOTION_SUCCESS = 'DELETE_PROMOTION_SUCCESS'

/* ---------------- AUTH CONSTANTS ---------------- */

export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST'
export type REGISTER_USER_REQUEST = typeof REGISTER_USER_REQUEST

export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export type REGISTER_USER_SUCCESS = typeof REGISTER_USER_SUCCESS

export const RESET_FETCH_SUCCESS = 'RESET_FETCH_SUCCESS'
export type RESET_FETCH_SUCCESS = typeof RESET_FETCH_SUCCESS

export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL'
export type REGISTER_USER_FAIL = typeof REGISTER_USER_FAIL

export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE'
export type CLEAR_AUTH_STATE = typeof CLEAR_AUTH_STATE

export const AUTHORIZATION_REQUEST = 'AUTHORIZATION_REQUEST'
export type AUTHORIZATION_REQUEST = typeof AUTHORIZATION_REQUEST

export const AUTHORIZATION_SUCCESS = 'AUTHORIZATION_SUCCESS'
export type AUTHORIZATION_SUCCESS = typeof AUTHORIZATION_SUCCESS

export const AUTHORIZATION_FAIL = 'AUTHORIZATION_FAIL'
export type AUTHORIZATION_FAIL = typeof AUTHORIZATION_FAIL

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export type CHANGE_PASSWORD_REQUEST = typeof CHANGE_PASSWORD_REQUEST

export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export type CHANGE_PASSWORD_SUCCESS = typeof CHANGE_PASSWORD_SUCCESS

export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL'
export type CHANGE_PASSWORD_FAIL = typeof CHANGE_PASSWORD_FAIL

export const CHECK_TOKEN_REQUEST = 'CHECK_TOKEN_REQUEST'
export type CHECK_TOKEN_REQUEST = typeof CHECK_TOKEN_REQUEST

export const CHECK_TOKEN_SUCCESS = 'CHECK_TOKEN_SUCCESS'
export type CHECK_TOKEN_SUCCESS = typeof CHECK_TOKEN_SUCCESS

export const CHECK_TOKEN_FAIL = 'CHECK_TOKEN_FAIL'
export type CHECK_TOKEN_FAIL = typeof CHECK_TOKEN_FAIL

export const USER_LOGOUT = 'USER_LOGOUT'

export const GET_VEHICLE_LIST_BY_OPERATOR_ID = 'GET_VEHICLE_LIST_BY_OPERATOR_ID'
export type GET_VEHICLE_LIST_BY_OPERATOR_ID = typeof GET_VEHICLE_LIST_BY_OPERATOR_ID

export const GET_VEHICLE_LIST_BY_OPERATOR_ID_SUCCESS = 'GET_VEHICLE_LIST_BY_OPERATOR_ID_SUCCESS'
export type GET_VEHICLE_LIST_BY_OPERATOR_ID_SUCCESS = typeof GET_VEHICLE_LIST_BY_OPERATOR_ID_SUCCESS

export const GET_VEHICLE_LIST_BY_OPERATOR_ID_FAIL = 'GET_VEHICLE_LIST_BY_OPERATOR_ID_FAIL'
export type GET_VEHICLE_LIST_BY_OPERATOR_ID_FAIL = typeof GET_VEHICLE_LIST_BY_OPERATOR_ID_FAIL

/* ---------------- PROVIDER PRODUCTS ---------------- */

export const FILTER_AVAILABLE_PRODUCTS_REQUEST = 'FILTER_AVAILABLE_PRODUCTS_REQUEST'

export const FILTER_AVAILABLE_PRODUCTS_SUCCESS = 'FILTER_AVAILABLE_PRODUCTS_SUCCESS'

export const FILTER_AVAILABLE_PRODUCTS_FAIL = 'FILTER_AVAILABLE_PRODUCTS_FAIL'

/* ---------------- GLOBAL SETTINGS ---------------- */

export enum GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN {
  CATEGORY = 'Category',
  NAME = 'Name',
  ABLE_TO_TRANSFER_TO_A_SEAT = 'Able to transfer to a seat'
}

export enum GLOBAL_SETTINGS_ASSISTANCE_COLUMN {
  CATEGORY = 'Category',
  TYPE = 'Type',
  INSTRUCTION = 'Instruction'
}

export const GS_FETCH_SERVICE_LEVELS_REQUEST = 'GS_FETCH_SERVICE_LEVELS_REQUEST'
export const GS_FETCH_SERVICE_LEVELS_SUCCESS = 'GS_FETCH_SERVICE_LEVELS_SUCCESS'
export const GS_FETCH_SERVICE_LEVELS_FAIL = 'GS_FETCH_SERVICE_LEVELS_FAIL'

export const GS_CREATE_SERVICE_LEVEL_REQUEST = 'GS_CREATE_SERVICE_LEVEL_REQUEST'
export const GS_CREATE_SERVICE_LEVEL_SUCCESS = 'GS_CREATE_SERVICE_LEVEL_SUCCESS'
export const GS_CREATE_SERVICE_LEVEL_FAIL = 'GS_CREATE_SERVICE_LEVEL_FAIL'

export const RECOVER_PASSWORD_REQUEST = 'RECOVER_PASSWORD_REQUEST'
export type RECOVER_PASSWORD_REQUEST = typeof RECOVER_PASSWORD_REQUEST

export const RECOVER_PASSWORD_SUCCESS = 'RECOVER_PASSWORD_SUCCESS'
export type RECOVER_PASSWORD_SUCCESS = typeof RECOVER_PASSWORD_SUCCESS

export const RECOVER_PASSWORD_FAIL = 'RECOVER_PASSWORD_FAIL'
export type RECOVER_PASSWORD_FAIL = typeof RECOVER_PASSWORD_FAIL

export const TEAM_MEMBER_PANE_TAB = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  PERMISSION: 'PERMISSION'
}
export type TEAM_MEMBER_PANE_TAB = typeof TEAM_MEMBER_PANE_TAB

export const tripJustCreated = 'trip just created'



// WEBPACK FOOTER //
// ./src/state/constants/index.tsx